import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../Actions/AllAction';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { hotelList, user_Details, hotelStatusUpdate, hotelCreate, adminCreate, hotelDelete, subscriptionListApi, subscribApiCall, versionListApi, refundAmountDetailsApi, hotelSubscriptionCancelApi, walinerSettingGet } from './Controller/OrganizationController';
import Utility from '../Utility/Utility';
import AutosuggestComponent from '../Utility/Components/AutosuggestComponent'
import CustomButton from '../Utility/Components/CustomButton'
import ModalGlobal from '../Utility/Components/ModalGlobal'
import { DebounceInput } from 'react-debounce-input';
import PopoverStickOnHover from '../Utility/Components/PopoverStickOnHover';
import GridActionContent from '../Utility/Components/GridActionContent';
import ErrorBoundary from '../Utility/Components/ErrorBoundary';
import ConfirmationAlert from '../Utility/Components/ConfirmationAlert';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import OrganizationAddEditModalContent from './Components/OrganizationAddEditModalContent';
import ValidateUtility from '../Utility/ValidateUtility';
import Currency from '../Utility/Components/Currency'
import { withNamespaces } from 'react-i18next';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import moment from 'moment';
import SubscribeModal from '../Utility/Components/SubscribeModal';
import { Country, State, City } from 'country-state-city';
import CustomNoRowsOverlay from '../Utility/Components/CustomNoRowsOverlay';
import PaymentModeModalContent from './Components/PaymentModeModalContent';
import ReactTooltip from 'react-tooltip';
import RefreshButton from '../Utility/Components/RefreshButton'
import parsePhoneNumber from 'libphonenumber-js';
import CustomInput from '../Utility/Components/CustomInput'
import WalinerConfigModalContent from './Components/WalinerConfigModalContent';
import WalinerTemplateModalContent from './Components/WalinerTemplateModalContent';
// import momenttz from 'moment-timezone';
import { allTimezones } from 'react-timezone-select';
import './Assets/css/organization.scss'
function Organization(props) {
    const history = useHistory();
    const [modules, setmodules] = useState([InfiniteRowModelModule]);
    const [defaultColDef, setdefaultColDef] = useState({
        flex: 1,
        minWidth: 50

    });

    const [components, setcomponents] = useState({
        loadingRenderer: (params) => {
            if (params.value !== undefined) {
                return params.value;
            } else {
                return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
            }
        },
    })

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridparams, setgridparams] = useState(null);
    const [subscribeModalFlag, setsubscribeModalFlag] = useState(false);
    const [subscriptionListData, setSubscriptionList] = useState([]);
    const [reservesubscriptionListData, setReserveSubscriptionList] = useState([]);
    const [selectedSubscription, setSelectedSubscription] = useState("");
    const [paymentModeModalFlag, setPaymentModeModalFlag] = useState(false);
    const [paymentModeModalHeaderTitle, setPaymentModeModalHeaderTitle] = useState("Add Payment");
    const [extendDays, setextendDays] = useState(7);
    const [isCheckedAgent, setIsCheckedAgent] = useState(false);
    const [selectedCancellationPolicy, setSelectedCancellationPolicy] = useState("withoutRefund");
    const [cancellationSubscriptionPopupFlag, setCancellationSubscriptionPopupFlag] = useState(false);
    const [cancellationSubscriptionRefundAmount, setCancellationSubscriptionRefundAmount] = useState("");
    const [cancellationSubscriptionRefundAmountError, setCancellationSubscriptionRefundError] = useState("");
    const [selectedRowSubscriptionData, setSelectedRowSubscriptionData] = useState("");

    const [columnDefs, setColumnDefs] = useState(
        [

            {
                headerName: 'Organization Name',
                field: "org_name",
                minWidth: 180,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        let concatname = params.data.org_name
                        if (params.data.org_name && concatname.length > 15) {
                            return <div className="usercursor"><span className="textrenderview">
                                <OverlayTrigger overlay={<Tooltip>{params.data && params.data.org_name != "" ? params.data.org_name : ""}</Tooltip>}>
                                    <span >
                                        {params.data && params.data.org_name != "" ? params.data.org_name : ""}
                                    </span>
                                </OverlayTrigger>
                            </span></div>
                        } else {
                            return (<div className="usercursor"><span className="textrenderview">{params.data && params.data.org_name != "" ? params.data.org_name : ""}</span></div>)
                        }

                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Corporate Address',
                field: "city",
                minWidth: 180,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('OrgMetaRelation') && params.data.OrgMetaRelation && params.data.OrgMetaRelation.hasOwnProperty('city') && params.data.OrgMetaRelation.city && params.data.OrgMetaRelation.city != "") {
                            if (params.data.OrgMetaRelation.city.length >= 20) {
                                return <div className="multiContentBox">
                                    <OverlayTrigger overlay={<Tooltip>{params.data.OrgMetaRelation.city}</Tooltip>}>
                                        <span >{(params.data.OrgMetaRelation.city).substring(0, 17) + "..."}</span>
                                    </OverlayTrigger>
                                </div>
                            } else {
                                return <div className="multiContentBox">
                                    <div className='contentBox'>{params.data.OrgMetaRelation.city}</div>
                                </div>
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Corporate Contact',
                field: "contact_number",
                minWidth: 180,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if ((params.data.hasOwnProperty('OrgMetaRelation') && params.data.OrgMetaRelation && params.data.OrgMetaRelation.hasOwnProperty('email') && params.data.OrgMetaRelation.email && params.data.OrgMetaRelation.email != "") || (params.data.hasOwnProperty('OrgMetaRelation') && params.data.OrgMetaRelation && params.data.OrgMetaRelation.hasOwnProperty('contact_number') && params.data.OrgMetaRelation.contact_number && params.data.OrgMetaRelation.contact_number != "")) {
                            return <div className="multiContentBox">
                                {params.data.OrgMetaRelation.hasOwnProperty('email') && params.data.OrgMetaRelation.email && params.data.OrgMetaRelation.email != "" &&
                                    <div className='contentBox'>
                                        {params.data.OrgMetaRelation.email.length >= 20 ?
                                            <OverlayTrigger overlay={<Tooltip>{params.data.OrgMetaRelation.email}</Tooltip>}>
                                                <span>{(params.data.OrgMetaRelation.email).substring(0, 17) + "..."}</span>
                                            </OverlayTrigger> :
                                            <span>{params.data.OrgMetaRelation.email}</span>
                                        }
                                    </div>
                                }
                                {params.data.OrgMetaRelation.hasOwnProperty('contact_number') && params.data.OrgMetaRelation.contact_number && params.data.OrgMetaRelation.contact_number != "" &&
                                    <div className='contentBox'>{params.data.OrgMetaRelation.contact_number.includes("+") ? params.data.OrgMetaRelation.contact_number : "+" + params.data.OrgMetaRelation.contact_number}</div>
                                }
                            </div>
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Admin',
                field: "email",
                minWidth: 150,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        const OrgUserRelation = params.data.OrgUserRelation || [];
                        if (OrgUserRelation.length > 0) {
                            const firstRelation = OrgUserRelation[0];
                            if (firstRelation.UserOrgBranchRoleRelation) {
                                const adminName = `${firstRelation.UserOrgBranchRoleRelation.first_name} ${firstRelation.UserOrgBranchRoleRelation.last_name}`;
                                const moreCount = OrgUserRelation.length - 1;

                                return (
                                    <div className={moreCount > 0 ? "multiContentBox multiline" : "multiContentBox"}>
                                        <div className="contentBox contentBoxAdmin">
                                            {adminName && adminName.length > 0 && (
                                                <>
                                                    {adminName.length >= 17 ? (
                                                        <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip>{adminName}</Tooltip>}>
                                                            <span>{adminName.substring(0, 14)}...</span>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <span>{adminName}</span>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        {moreCount > 0 && (
                                            <span
                                                className="showMore"
                                                onClick={() => showPopup(OrgUserRelation)}
                                            >
                                                +{moreCount} more
                                            </span>
                                        )}
                                    </div>
                                );
                            }
                        }
                    }
                    return null;
                },
            },
            {
                headerName: 'Admin Details',
                field: "email",
                minWidth: 180,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        const OrgUserRelation = params.data.OrgUserRelation || [];
                        if (OrgUserRelation.length > 0) {
                            const firstRelation = OrgUserRelation[0];
                            if (firstRelation.UserOrgBranchRoleRelation) {
                                const adminEmail = firstRelation.UserOrgBranchRoleRelation.email;
                                const contactNumber =
                                    firstRelation.UserOrgBranchRoleRelation.contact_number;
                                const formattedContactNumber = contactNumber.includes("+")
                                    ? contactNumber
                                    : `+${contactNumber}`;
                                const moreCount = OrgUserRelation.length - 1;

                                return (
                                    <div className="multiContentBox adminDetailsBox">
                                        <div className="contentBox">
                                            {adminEmail && adminEmail.length > 0 && (
                                                <>
                                                    {adminEmail.length >= 20 ? (
                                                        <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip>{adminEmail}</Tooltip>}>
                                                            <span>{adminEmail.substring(0, 17)}...</span>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <span>{adminEmail}</span>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        <div className={moreCount > 0 ? "contentBox contentBoxMore" : "contentBox"}>
                                            <span className='phoneNumberBox'>{formattedContactNumber}</span>
                                            {moreCount > 0 && (
                                                <span
                                                    className="showMore"
                                                    onClick={() => showPopup(OrgUserRelation)}
                                                >
                                                    +{moreCount} more
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                        }
                    }
                    return null;
                },
            },

            {
                headerName: "Subscription",
                field: "subscription_end_date",
                minWidth: 190,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params) {
                        if (params.data && params.data.hasOwnProperty('OrganisationSubscriptions') && params.data.OrganisationSubscriptions.length > 0) {
                            let subscriptionType = params.data.hasOwnProperty('OrganisationSubscriptions') && params.data.OrganisationSubscriptions.length > 0 && params.data.OrganisationSubscriptions[0].SubscriptionTypeDetails.subscription_name != "" ? params.data.OrganisationSubscriptions[0].SubscriptionTypeDetails.subscription_name : ""

                            let subscriptionStartDate = params.data.hasOwnProperty('OrganisationSubscriptions') && params.data.OrganisationSubscriptions.length > 0 && params.data.OrganisationSubscriptions[0].subscription_start_date != "" ? params.data.OrganisationSubscriptions[0].subscription_start_date : ""

                            let subscriptionStartDateFormat = subscriptionStartDate != "" ? moment(subscriptionStartDate.toString()).format('DD-MM-YYYY') : ""

                            let subscriptionEndDate = params.data.hasOwnProperty('OrganisationSubscriptions') && params.data.OrganisationSubscriptions.length > 0 && params.data.OrganisationSubscriptions[0].subscription_end_date != "" ? params.data.OrganisationSubscriptions[0].subscription_end_date : ""

                            let subscription_extended_date = params.data.hasOwnProperty('OrganisationSubscriptions') && params.data.OrganisationSubscriptions.length > 0 && params.data.OrganisationSubscriptions[0].subscription_extended_date && params.data.OrganisationSubscriptions[0].subscription_extended_date != "" ? params.data.OrganisationSubscriptions[0].subscription_extended_date : ""
                            let subscriptionEndDateFormat = "";
                            if (subscription_extended_date != "") {
                                subscriptionEndDateFormat = moment(subscription_extended_date.toString()).format('DD-MM-YYYY')
                            } else {
                                subscriptionEndDateFormat = moment(subscriptionEndDate.toString()).format('DD-MM-YYYY')
                            }
                            return <div className="multiContentBox subscriptionBox">
                                {params.data.subscption_status == 0 &&
                                    <>
                                        <div className='contentBox expired' style={{ 'color': 'red' }}>Expired</div>
                                        <div className="contentBox">{subscriptionStartDateFormat} - {subscriptionEndDateFormat}</div>
                                    </>}
                                {params.data.subscption_status == 1 &&
                                    <>
                                        <div className='contentBox'>{subscriptionType}</div>
                                        <div className="contentBox">{subscriptionStartDateFormat} - {subscriptionEndDateFormat}</div>
                                    </>}
                                {params.data.subscption_status == 2 &&
                                    <>
                                        <div className='contentBox'>{subscriptionType}</div>
                                        <div className="contentBox">{subscriptionStartDateFormat} - {subscriptionEndDateFormat}</div>
                                    </>}
                                {params.data.subscption_status == 4 &&
                                    <>
                                        <div className='contentBox expired' style={{ 'color': 'red' }}>Cancelled</div>
                                        <div className="contentBox">{params.data?.OrganisationSubscriptions[0]?.remarks || ""}</div>
                                    </>}
                                {params.data.subscption_status == 3 && params.data.hasOwnProperty('OrganisationSubscriptions') && params.data.OrganisationSubscriptions.length > 0 && params.data.OrganisationSubscriptions[0].hasOwnProperty('SubscriptionTypeDetails') && parseInt(params.data.OrganisationSubscriptions[0].SubscriptionTypeDetails.subscription_price) == 0 &&
                                    <>
                                        <>
                                            <div className='contentBox freeTrialColor'>Free Trial</div>
                                            <div className="contentBox">{subscriptionStartDateFormat} - {subscriptionEndDateFormat}</div>
                                        </>
                                    </>}
                            </div>
                        } else {
                            return null
                        }
                    } else {
                        return null
                    }
                },
            },

            {
                headerName: "",
                field: "is_active",
                minWidth: 140,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params) {
                        if (params.data) {
                            return <button className="edittext">
                                <div className="switch_btn_customize_box">
                                    <BootstrapSwitchButton checked={params.data && params.data.is_active ? params.data.is_active : false}
                                        onChange={() => handleChangeSwitchButton(params.data)}
                                        onlabel='Active'
                                        onstyle='success'
                                        offlabel='Inactive'
                                        offstyle='danger'
                                        style='w-100 mx-3'
                                    />
                                </div>
                            </button>
                        } else {
                            return null
                        }
                    } else {
                        return null
                    }
                },
            },
            {
                headerName: "",
                field: "edit",
                width: 90,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        return <div className="actionablePopupBox">
                            <button className="ellipsisIcon" onClick={(e) => actionModalfunction(e, params)}><i className="fa fa-ellipsis-v"></i></button>
                        </div>
                    } else {
                        return null;
                    }
                },
            }

        ]
    )

    const actionOutsideClickRef = useRef();
    const [searchHotelName, setSearchHotelName] = useState("");
    const [actionModalflag, setActionModalflag] = useState(false);
    const [overlayHight, setOverlayHight] = useState(0);
    const [overlayWidth, setOverlayWidth] = useState(0);
    const [gridObjData, setGridObjData] = useState({});
    const [selectedStatus, setSelectedStatus] = useState("");
    const [statusList, setStatusList] = useState([
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
    ]);
    const [hotelCreateModalFlag, setHotelCreateModalFlag] = useState(false);

    const [formData, setFormData] = useState({
        "hotel_name": "",
        "hotel_email": "",
        "hotel_contact_number": "",
        "hotel_address1": "",
        "hotel_address2": "",
        "hotel_city": "",
        "hotel_state": "",
        "hotel_zip_code": "",
        "hotel_country": "india",
        "hotel_gstin_number": "",
        "hotel_pan_number": "",
        "first_name": "",
        "last_name": "",
        "email": "",
        "contact_number": "",
        "profile_image": "",
        "selectedTimezone": "",
        "max_branch": "",
        "version": "",
        "is_standalone": false,
        "is_mfa_required": false,
        'agency_mfa_required': false,
        "domain": "",
        "is_multi_threaded": 'singleThread',
        "agency_name_agent": "",
        "agency_name": "",
        "agency_image": "",
        "agency_email": "",
        "agency_address1": "",
        "agency_address2": "",
        "agency_zipcode": "",
        "agency_country": "india",
        "agency_contact_number": "",
        "agency_state": "",
        "agency_city": "",
        "agency_gstin_number": "",
        "agency_pan_number": "",
        "is_agency": false,
        "allow_main_store": false,
        "is_waliner_enabled":false
    })

    const [errorFormData, setErrorFormData] = useState({
        "hotel_name": "",
        "hotel_email": "",
        "hotel_contact_number": "",
        "hotel_address1": "",
        "hotel_address2": "",
        "hotel_city": "",
        "hotel_state": "",
        "hotel_zip_code": "",
        "hotel_country": "",
        "hotel_gstin_number": "",
        "hotel_pan_number": "",
        "first_name": "",
        "last_name": "",
        "email": "",
        "contact_number": "",
        "profile_image": "",
        "selectedTimezone": "",
        "max_branch": "",
        "version": "",
        "is_standalone": false,
        "is_mfa_required": false,
        "domain": "",
        "is_multi_threaded": "",
        "agency_name_agent": "",
        "agency_name": "",
        "agency_image": "",
        "agency_email": "",
        "agency_address1": "",
        "agency_address2": "",
        "agency_zipcode": "",
        "agency_country": "",
        "agency_contact_number": "",
        "agency_state": "",
        "agency_city": "",
        "agency_gstin_number": "",
        "agency_pan_number": "",
        "allow_main_store": "",
        "is_waliner_enabled":""
    })
    const [selectedVersion, setSelectedVersion] = useState({})
    const [versionList, setVersionList] = useState([

    ]);
    //profile image
    const [addProfileImagePreviewShow, setAddProfileImagePreviewShow] = useState(false);
    const [imageCropModalFlag, setImageCropModalFlag] = useState(false);
    const [src, setSrc] = useState(null);
    const [addprofileImageSelected, setAddprofileImageSelected] = useState(require('../Utility/Public/images/profile-back.png'));


    const [crop, setCrop] = useState({
        unit: '%',
        width: 30,
    })
    const [croppedImageUrl, setCroppedImageUrl] = useState("");
    const imageRef = useRef();

    //hotel image
    const [addHotelImagePreviewShow, setAddHotelImagePreviewShow] = useState(false);
    const [hotelImageCropModalFlag, setHotelImageCropModalFlag] = useState(false);
    const [hotelSrc, setHotelSrc] = useState(null);
    const [addHotelImageSelected, setAddHotelImageSelected] = useState(require('../Utility/Public/images/hotel.png'));
    const [hotelCrop, setHotelCrop] = useState({
        unit: '%',
        width: 30,
    })
    const [hotelCroppedImageUrl, setHotelCroppedImageUrl] = useState("");
    const hotelImageRef = useRef();

    //Edite flags
    const [editedHotelFlag, setEditedHotelFlag] = useState(false);
    const [editedHotelId, setEditedHotelId] = useState("");
    const [editedAdminId, setEditedAdminId] = useState("");
    const [zoominzoomoutflag, setZoominzoomoutflag] = useState("");
    const [hotelModalTitle, setHotelModalTitle] = useState("");
    const [editRowData, setEditRowData] = useState({});

    //delete flag
    const [deleteConfirmationAlertModal, setDeleteConfirmationAlertModal] = useState(false);
    const [deleteBodySecondContent, setDeleteBodySecondContent] = useState("");
    const [hotelDeleteObj, setHotelDeleteObj] = useState({});
    const [CountryList, setCountryList] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({ "label": "India", "value": "india", "country_code": "91", "iso_code": "IN" });
    const [selectedCountryCode, setSelectedCountryCode] = useState("in");
    const [phoneNumberCountryCode, setPhoneNumberCountryCode] = useState("in");
    const [phoneNumberDialCode, setPhoneNumberDialCode] = useState("91");
    const [phoneNumberCountryCodeAdmin, setPhoneNumberCountryCodeAdmin] = useState("in");
    const [phoneNumberDialCodeAdmin, setPhoneNumberDialCodeAdmin] = useState("91");

    const [selectedState, setSelectedState] = useState({});
    const [StateList, setStateList] = useState([]);
    const [selectedCity, setSelectedCity] = useState('');
    const [CityList, setCityList] = useState([]);
    const [saveCountryId, setCountryId] = useState("IN");
    const [IsEditFormOpen, setIsEditFormOpen] = useState(false);
    const [isEditFormOpenTimeState, setIsEditFormOpenTimeState] = useState(false);
    const [isEditFormOpenTimeCity, setIsEditFormOpenTimeCity] = useState(false);
    const [EditDataObj, setEditDataObj] = useState({});
    const gridRef = useRef();
    const [subscriptionModalTitle, setSubscriptionModalTitle] = useState("");
    const [isAnimating, setIsAnimating] = useState(true);
    //agent details=============
    const [phoneNumberCountryCodeForAgency, setPhoneNumberCountryCodeForAgency] = useState("in");
    const [phoneNumberDialCodeForAgency, setPhoneNumberDialCodeForAgency] = useState("91");
    const [selectedCountryForAgency, setSelectedCountryForAgency] = useState({ "label": "India", "value": "india", "country_code": "91", "iso_code": "IN" });
    const [CountryListForAgency, setCountryListForAgency] = useState([]);
    const [selectedCountryCodeForAgency, setSelectedCountryCodeForAgency] = useState("in");
    const [selectedStateForAgency, setSelectedStateForAgency] = useState({});
    const [StateListForAgency, setStateListForAgency] = useState([]);
    const [selectedCityForAgency, setSelectedCityForAgency] = useState('');
    const [CityListForAgency, setCityListForAgency] = useState([]);
    const [saveCountryIdForAgency, setCountryIdForAgency] = useState("IN");
    const [isEditFormOpenTimeStateForAgency, setIsEditFormOpenTimeStateForAgency] = useState(false);
    const [isEditFormOpenTimeCityForAgency, setIsEditFormOpenTimeCityForAgency] = useState(false);
    const [adminDetailsPopUpShowFlag, setAdminDetailsPopUpShowFlag] = useState(false);
    const [adminDetailsData, setAdminDetailsData] = useState([]);

    //waliner configuration
    const [walinerConfigModalFlag, setWalinerConfigModalFlag] = useState(false);
    const [walinerConfigModalData, setWalinerConfigModalData] = useState({});
    const [walinerTemplateModalFlag, setWalinerTemplateModalFlag] = useState(false);
    const [walinerTemplateModalData, setWalinerTemplateModalData] = useState({});

    //hotel list aggrid ongridready function
    const onGridReady = useCallback((params) => {
        setgridparams(params)
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        var datasource = serverSideDataSource()
        params.api.setDatasource(datasource);
    });

    //aggrid reset data fn
    const resetDataGrid = () => {
        var datasource = serverSideDataSource()
        gridApi.setDatasource(datasource);
    }

    //country list dropdown option generate
    const getCountryOption = () => {
        if (CountryList.length == 0) {
            setCountryList([]);
            Country.getAllCountries().map((countryObj) => {
                setCountryList(prevArray => [...prevArray, { label: countryObj.name, value: countryObj.isoCode, country_code: countryObj.phonecode, iso_code: countryObj.isoCode }]);
            })
        }
    }

    //state list dropdown option generate
    const getStateOption = (countryId = "") => {
        setStateList([]);
        if (countryId != "") {
            State.getStatesOfCountry(countryId).map((stateObj) => {
                setStateList(prevArray => [...prevArray, { label: stateObj.name, value: stateObj.isoCode, country_id: stateObj.countryCode }]);
            })
        } else {
            setStateList([]);
        }
    }


    //add subscription modal open function
    const opensubscribeModal = (gridObj, type = "") => {
        if (gridObjData.data.subscption_status == 3) {
            setSubscriptionModalTitle("Add Subscription")
        }
        if (gridObjData.data.subscption_status == 0 || gridObjData.data.subscption_status == 1) {
            setSubscriptionModalTitle("Renew Subscription")
        }
        if (type == 'Extend') {
            setSubscriptionModalTitle("Extend Subscription")
            let selectdFilter = subscriptionListData.filter((obj) => obj.id == gridObj.data.OrganisationSubscriptions[0].SubscriptionTypeDetails.id)
            if (selectdFilter.length > 0) {
                setSelectedSubscription(selectdFilter[0])
            }
        }
        setsubscribeModalFlag(true);
    }

    //subscription modal close fn
    const closesubscribeModalFn = () => {
        setsubscribeModalFlag(false)
        setSelectedSubscription("")
        setSubscriptionModalTitle("")
        setextendDays(7)
    }

    const closesubscribeModeModalFnChild = () => {
        closesubscribeModalFn();
    }

    //fetch city list option according to country and state
    const getCityOption = (state_code = "", country_code = "") => {
        setCityList([]);
        if (state_code != "") {
            City.getCitiesOfState(country_code.toUpperCase().toString(), state_code.toUpperCase().toString()).map((cityObj) => {
                setCityList(prevArray => [...prevArray, { label: cityObj.name, value: cityObj.name, country_id: cityObj.countryCode }]);
            })
        }
    }

    //Hotel list aggrid serverside api call
    const serverSideDataSource = () => {
        return {
            getRows(params) {
                const { startRow, endRow, filterModel, sortModel } = params
                const { loaderStateTrue, loaderStateFalse } = props;
                loaderStateTrue();
                setIsAnimating(true);
                //dataset create
                let filters = {};
                let filter_op = {};
                let globalQueryParamshash = {};
                globalQueryParamshash["offset"] = startRow;
                globalQueryParamshash["limit"] = parseInt(process.env.PAGE_DATA_LIMIT);
                // globalQueryParamshash["list_by"] = "hotel";
                if (searchHotelName.trim() != "") {
                    globalQueryParamshash['search_attr'] = searchHotelName.trim()
                    filter_op = Object.assign(filter_op, { "search_attr": "substring" });
                }
                if (selectedStatus != "") {
                    globalQueryParamshash['is_active'] = selectedStatus.value == "active" ? true : false;
                }
                if (sortModel.length > 0) {
                    const statusSortExists = sortModel.some(item => item.sort === "desc" || "asc" && item.colId === "subscription_end_date");
                    if (!statusSortExists) {
                        // sortModel.push({ "sort": "asc", "colId": "subscription_end_date" });
                    }
                    globalQueryParamshash['sort'] = sortModel;
                } else {
                    // globalQueryParamshash['sort'] = [{ "sort": "asc", "colId": "subscription_end_date" }];
                }
                if (Object.keys(filter_op).length > 0) {
                    filters["filter_op"] = JSON.stringify(filter_op);
                }
                filters['filters'] = JSON.stringify(globalQueryParamshash)

                //hotel list api hit
                hotelList(filters).then((response) => {
                    if (response.success) {
                        if (response.data.length == 0 && startRow == 0) {
                            gridRef.current.api.showNoRowsOverlay();
                        } else {
                            gridRef.current.api.hideOverlay();
                        }
                        params.successCallback(response.data, response.total);
                        loaderStateFalse();
                        setIsAnimating(false);
                    } else {
                        console.error(error);
                        params.failCallback();
                        Utility.toastNotifications("Something went wrong !", "Error", "error")
                        loaderStateFalse();
                        setIsAnimating(false);
                    }
                }).catch((error) => {
                    console.error("************error*************", error)
                    if (error) {
                    }
                    loaderStateFalse();
                    setIsAnimating(false);
                    if (error.message == "Network Error") {
                    }
                });
            }
        };
    }

    //fetch hotel image
    const profileImageUi = (id) => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = props;
            loaderStateTrue();
            let data = {};
            data["filters"] = JSON.stringify(JSON.parse(process.env.THUMB_NAIL_SIZE))
            user_Details(id, data).then((response) => {
                if (response.success) {
                    let responseUserDetails = response.data[0].user_details
                    if (responseUserDetails && Object.keys(responseUserDetails.profile_img).length > 0) {
                        resolve(responseUserDetails.profile_img.file_obj)
                    }
                    else {
                        resolve(responseUserDetails.profile_img)
                    }
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
        })
        return promise;

    }

    //hotel listing aggrid option configure
    const gridOptions = useMemo(
        () => ({
            infiniteInitialRowCount: 1,
            paginationPageSize: 100,
            rowBuffer: 0,
            rowModelType: 'infinite',
            suppressCellSelection: true,
            suppressHorizontalScroll: true,
        }),
        []
    )

    //hotel search filter onclick handler
    const handleSearchValue = (e) => {
        if (searchHotelName.trim() != e.target.value.trim()) {
            setSearchHotelName(e.target.value)
        }
    }
    const walinerConfigFn = async (gridObj) => {
        console.log("gridObj", gridObj);
        const { loaderStateTrue, loaderStateFalse } = props;

        try {
            loaderStateTrue();

            let filterObj = {
                filters: JSON.stringify([{
                    resource_name: "WalinerConfiguration",
                    columns: ["id", "org_id", "whatsapp_phonenumber_id", "text_message_url", "template_message_url", "message_token"],
                    column_filters: [{ org_id: [gridObj.data.id, 0] }]
                }]),
                filter_op: JSON.stringify([{
                    resource_name: "WalinerConfiguration",
                    org_id: "in"
                }])
            };

            const res = await walinerSettingGet(filterObj);  // Make sure this API exists
            setWalinerConfigModalData(res || {});
            setWalinerConfigModalFlag(true);
        } catch (err) {
            console.error("Error fetching Waliner config:", err);
            Utility.toastNotifications("Failed to load Waliner configuration", "Error", "error");
            setWalinerConfigModalData({});
        } finally {
            loaderStateFalse();
        }
    };

    const closeWalinerConfigModalFn = () => {
        setWalinerConfigModalFlag(false);
        setWalinerConfigModalData({});
    }
    const closeWalinerTemplateModalFn = () => {
        setWalinerTemplateModalFlag(false);
        setWalinerTemplateModalData({});
    }
    // const walinerTemplateFn = async (data) => {
    //     const { loaderStateTrue, loaderStateFalse } = props;
    //     try {
    //         loaderStateTrue();
    //         let filterObj = {
    //             filters: JSON.stringify([{
    //                 resource_name: "WhatsappTemplateMapping",
    //                 columns: ["id", "org_id", "template_type", "template_name"],
    //                 column_filters: [{ org_id: [gridObjData.data.id, 0] }]
    //             }]),
    //             filter_op: JSON.stringify([{
    //                 resource_name: "WhatsappTemplateMapping",
    //                 org_id: "in"
    //             }])
    //         }
    //         return;
    //         walinerSettingGet(filterObj).then(res => {
    //             setWalinerTemplateModalData(res || {});
    //             loaderStateFalse();
    //         }).catch(err => {
    //             console.error("Error fetching payment details:", err);
    //             loaderStateFalse();
    //         });
    //     } catch (e) {
    //         setWalinerTemplateModalData({});
    //     }
    //     setWalinerTemplateModalFlag(true);
    // }

    //when search name change reset grid api hit
    const walinerTemplateFn = async (gridObj) => {
        const { loaderStateTrue, loaderStateFalse } = props;

        try {
            loaderStateTrue();

            let filterObj = {
                filters: JSON.stringify([{
                    resource_name: "WhatsappTemplateMapping",
                    columns: ["id", "org_id", "template_type", "template_name"],
                    column_filters: [{ org_id: [gridObj.data.id, 0] }]
                }]),
                filter_op: JSON.stringify([{
                    resource_name: "WhatsappTemplateMapping",
                    org_id: "in"
                }])
            };

            console.log("Fetching Waliner Templates for org:", gridObj.data.id);

            const res = await walinerSettingGet(filterObj);
            console.log("Waliner Template Response:", res);

            setWalinerTemplateModalData(res || {});
            setWalinerTemplateModalFlag(true);

        } catch (err) {
            console.error("Error fetching Waliner Templates:", err);
            Utility.toastNotifications("Failed to load Waliner Templates", "Error", "error");
            setWalinerTemplateModalData({});
        } finally {
            loaderStateFalse();
        }
    };
    useEffect(() => {
        if (searchHotelName != "") {
            resetDataGrid()
        }
        if (searchHotelName.length == 0 && gridparams) {
            resetDataGrid()
        }
    }, [searchHotelName])

    //clear hotel search filter
    const clearSearchValue = () => {
        setSearchHotelName("");
    }

    //edit action modal outside click close fn 
    useEffect(() => {
        const handleMouseDown = (event) => {
            handleClickOutside(event);
        };
        document.body.addEventListener('mousedown', handleMouseDown);
        return () => {
            document.body.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);

    //three dot action menu onclick fn
    const actionModalfunction = (e, gridObj) => {
        e.stopPropagation();
        let width = (parseInt(e.clientX) - 200) + 'px';
        let height = (parseInt(e.clientY) - 50) + 'px';
        setActionModalflag(true);
        setOverlayHight(height);
        setOverlayWidth(width);
        setGridObjData(gridObj);

    }

    //grid action modal outside click fn 
    const handleClickOutside = (event) => {
        if (actionOutsideClickRef.current && !actionOutsideClickRef.current.contains(event.target)) {
            setActionModalflag(false);
            setOverlayHight(0);
            setOverlayWidth(0);
        }
    };

    //edit hotel list , edit button click fn
    const editHotel = (data) => {
        let dataSet = data.data
        if (data.data?.hasOwnProperty('is_active') && data.data?.is_active) {
            getVersionListApi();
            initiallyCuntryStateCitySelect(dataSet.country, dataSet.state)
            setIsEditFormOpenTimeState(true);
            setIsEditFormOpenTimeCity(true);
            setHotelModalTitle("Edit Organization")
            setEditedHotelFlag(true)
            setEditedHotelId(data.data.id)
            // setEditedAdminId(data.data.hasOwnProperty('OrgUserRelation') && data.data.OrgUserRelation[0].hasOwnProperty('UserOrgBranchRoleRelation') ? data.data.OrgUserRelation[0].UserOrgBranchRoleRelation.id : "")
            setEditDataObj(data.data)
            setIsEditFormOpen(true);
            setEditRowData(data.data)
            //Agency========
            setIsEditFormOpenTimeStateForAgency(true)
            setIsEditFormOpenTimeCityForAgency(true)
        } else {
            // Utility.toastNotifications("This hotel's current status is inactive. Alter this hotel's status if you wish to make any changes to it.", "Warning", "warning")
            Utility.toastNotifications("This organization current status is inactive. Alter this organization status if you wish to make any changes to it.", "Warning", "warning")
        }
    }

    // For country set in edit mode after fetch country list
    useEffect(() => {
        if (editedHotelFlag && CountryList.length > 0 && isEditFormOpenTimeState) {
            let gridData = EditDataObj
            let countryValue = (gridData.OrgMetaRelation && gridData.OrgMetaRelation.country) || gridData.country || null;
            if (countryValue != null) {
                let countryListFilter = CountryList.filter((el) => {
                    return el.label.toLowerCase() == countryValue.toLowerCase();
                });
                if (countryListFilter.length > 0) {
                    setCountryId(countryListFilter[0].value);
                    getStateOption(countryListFilter[0].iso_code);
                } else {
                    getStateOption("IN");
                }

                setIsEditFormOpenTimeState(false);
            } else {
                getStateOption("IN");
            }
        }

    }, [editedHotelFlag, CountryList])

    // For State set in edit mode after fetch state list
    useEffect(() => {
        if (editedHotelFlag && StateList.length > 0 && isEditFormOpenTimeCity) {
            let gridData = EditDataObj
            let stateValue = (gridData.OrgMetaRelation && gridData.OrgMetaRelation.state) || gridData.state || null;
            if (stateValue != null) {
                let stateListFilter = StateList.filter((el) => {
                    return el.label.toLowerCase() == stateValue.toLowerCase();
                });
                if (stateListFilter.length > 0) {
                    getCityOption(stateListFilter[0].value, saveCountryId);
                } else {
                    getCityOption("WB", "IN");
                }
                setIsEditFormOpenTimeCity(false);
            } else {
                getCityOption("WB", "IN");
            }
        }
    }, [editedHotelFlag, StateList])


    // For agency country set in edit mode after fetch country list
    useEffect(() => {
        if (editedHotelFlag && CountryListForAgency.length > 0 && isEditFormOpenTimeStateForAgency) {
            let gridData = EditDataObj
            if (gridData.hasOwnProperty("agency_country") && gridData.agency_country != null) {
                let countryListFilter = CountryListForAgency.filter((el) => {
                    return el.label.toLowerCase() == gridData.agency_country.toLowerCase();
                });
                if (countryListFilter.length > 0) {
                    setCountryIdForAgency(countryListFilter[0].value);
                    getStateOptionForAgency(countryListFilter[0].iso_code);
                } else {
                    getStateOptionForAgency("IN");
                }

                setIsEditFormOpenTimeStateForAgency(false);
            } else {
                getStateOptionForAgency("IN");
            }
        }

    }, [editedHotelFlag, CountryListForAgency])

    // For Agent State set in edit mode after fetch state list
    useEffect(() => {
        if (editedHotelFlag && StateListForAgency.length > 0 && isEditFormOpenTimeCityForAgency) {
            let gridData = EditDataObj
            if (gridData.hasOwnProperty("agency_state") && gridData.agency_state != null) {
                let stateListFilter = StateListForAgency.filter((el) => {
                    return el.label.toLowerCase() == gridData.agency_state.toLowerCase();
                });
                if (stateListFilter.length > 0) {
                    getCityOptionForAgency(stateListFilter[0].value, saveCountryIdForAgency);
                } else {
                    getCityOptionForAgency("WB", "IN");
                }
                setIsEditFormOpenTimeCityForAgency(false);
            } else {
                getCityOptionForAgency("WB", "IN");
            }
        }

    }, [editedHotelFlag, StateListForAgency])

    //after fetch state,country,city edit hotel form open and set all the selected hotel data
    useEffect(() => {
        if (editedHotelFlag && IsEditFormOpen && CountryList.length > 0 && StateList.length > 0 && CityList.length > 0 && CountryListForAgency.length > 0 && StateListForAgency.length > 0 && CityListForAgency.length > 0 && versionList.length > 0) {
            setEditData(EditDataObj)
            setIsEditFormOpen(false);
        }
    }, [editedHotelFlag, CountryList, StateList, CityList, CountryListForAgency, StateListForAgency, CityListForAgency, versionList])

    useEffect(() => {
    }, [editedHotelId, editedAdminId])

    useEffect(() => {
    }, [editRowData])

    //Hotel edit form data set fn
    const setEditData = (dataSet) => {
        const timezonesArray = Object.keys(allTimezones).map((key) => ({
            value: key,
            label: allTimezones[key],
        }));
        if (dataSet != "") {
            let formDataValue = 'singleThread';
            if (dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('is_multi_threaded') && dataSet.OrgMetaRelation.is_multi_threaded != null) {
                if (dataSet.OrgMetaRelation.is_multi_threaded === 0) {
                    formDataValue = 'singleThread';
                } else if (dataSet.OrgMetaRelation.is_multi_threaded === 1) {
                    formDataValue = 'multiThread';
                } else if (dataSet.OrgMetaRelation.is_multi_threaded === 2) {
                    formDataValue = 'registerHotelRepresentative';
                }
            }
            if (dataSet.agency_included) {
                setIsCheckedAgent(true)
            }
            setFormData({
                "hotel_name": dataSet.org_name != "" ? dataSet.org_name : "",
                "agency_name": dataSet?.agency_name != "" ? dataSet.agency_name : "",
                "hotel_email": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('email') && dataSet.OrgMetaRelation.email && dataSet.OrgMetaRelation.email != "" ? dataSet.OrgMetaRelation.email : "",
                "hotel_contact_number": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('contact_number') && dataSet.OrgMetaRelation.contact_number && dataSet.OrgMetaRelation.contact_number != "" ? dataSet.OrgMetaRelation.contact_number : "",
                "hotel_address1": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('address1') && dataSet.OrgMetaRelation.address1 && dataSet.OrgMetaRelation.address1 != "" ? dataSet.OrgMetaRelation.address1 : "",
                "hotel_address2": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('address2') && dataSet.OrgMetaRelation.address2 && dataSet.OrgMetaRelation.address2 != "" ? dataSet.OrgMetaRelation.address2 : "",
                "hotel_zip_code": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('zip') && dataSet.OrgMetaRelation.zip && dataSet.OrgMetaRelation.zip != "" ? dataSet.OrgMetaRelation.zip : "",
                "hotel_gstin_number": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('gstin_number') && dataSet.OrgMetaRelation.gstin_number && dataSet.OrgMetaRelation.gstin_number != "" ? dataSet.OrgMetaRelation.gstin_number : "",
                "hotel_pan_number": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('pan_number') && dataSet.OrgMetaRelation.pan_number && dataSet.OrgMetaRelation.pan_number != "" ? dataSet.OrgMetaRelation.pan_number : "",
                "version": dataSet.hasOwnProperty('version_id') && dataSet.version_id ? dataSet.version_id : "",
                "domain": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('domain') && dataSet.OrgMetaRelation.domain && dataSet.OrgMetaRelation.domain != "" ? dataSet.OrgMetaRelation.domain : "",
                "is_multi_threaded": formDataValue,
                "is_standalone": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('is_global') && dataSet.OrgMetaRelation.is_global != null ? dataSet.OrgMetaRelation.is_global == true ? true : false : false,
                "is_mfa_required": dataSet.hasOwnProperty('is_mfa_required') && dataSet.is_mfa_required != null ? dataSet.is_mfa_required == true ? true : false : false,
                "agency_mfa_required": dataSet.hasOwnProperty('agency_mfa_required') && dataSet.agency_mfa_required != null ? dataSet.agency_mfa_required == true ? true : false : false,
                "is_agency": dataSet.hasOwnProperty('org_type') && dataSet.org_type != null ? dataSet.org_type == 'agent' ? true : false : false,
                "agency_image": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.agency_logo != null && dataSet.OrgMetaRelation.agency_logo != "" ? JSON.parse(dataSet.OrgMetaRelation.agency_logo) : "",
                "hotel_country": "",
                "hotel_state": "",
                "hotel_city": "",
                "agency_email": dataSet.agency_email != "" ? dataSet.agency_email : "",
                "agency_contact_number": dataSet.agency_contact_number != "" ? dataSet.agency_contact_number : "",
                "agency_address1": dataSet.agency_address1 != "" ? dataSet.agency_address1 : "",
                "agency_address2": dataSet.agency_address2 != "" ? dataSet.agency_address2 : "",
                "agency_zipcode": dataSet.agency_zipcode != "" ? dataSet.agency_zipcode : "",
                "agency_gstin_number": dataSet.agency_gstin_number != "" ? dataSet.agency_gstin_number : "",
                "agency_pan_number": dataSet.agency_pan_number != "" ? dataSet.agency_pan_number : "",
                "agency_country": "",
                "agency_state": "",
                "agency_city": "",
                "max_branch":dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('max_branch') && dataSet.OrgMetaRelation.max_branch && dataSet.OrgMetaRelation.max_branch != "" ? dataSet.OrgMetaRelation.max_branch : "",
                "allow_main_store": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('allow_main_store') && dataSet.OrgMetaRelation.allow_main_store && dataSet.OrgMetaRelation.allow_main_store != null ? dataSet.OrgMetaRelation.allow_main_store : false,
                "is_waliner_enabled": dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('is_waliner_enabled') && dataSet.OrgMetaRelation.is_waliner_enabled && dataSet.OrgMetaRelation.is_waliner_enabled != null ? dataSet.OrgMetaRelation.is_waliner_enabled : false
            })

            if (dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('version_id') && dataSet.OrgMetaRelation.version_id) {
                let versionListFilter = versionList.find((el) => {
                    console.log(el.value)
                    return el.value == dataSet.OrgMetaRelation.version_id
                });
                if (versionListFilter) {
                    setSelectedVersion(versionListFilter)
                }
            }
            let countryListFilter = [{ "label": "India", "value": "india" }]
            let county = [...CountryList]

            if (dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('country') && dataSet.OrgMetaRelation.country && dataSet.OrgMetaRelation.country != "" && CountryList) {
                countryListFilter = CountryList.filter((el) => {
                    return el.label.toLowerCase() == dataSet.OrgMetaRelation.country.toLowerCase();
                });
                if (countryListFilter.length > 0) {
                    setFormData((prevObject) => ({
                        ...prevObject,
                        hotel_country: countryListFilter[0].label.toLowerCase().toString(),
                    }));
                    setSelectedCountry({ "label": countryListFilter[0].label, "value": countryListFilter[0].value })
                    setSelectedCountryCode(countryListFilter[0].iso_code.toLowerCase().toString())
                }
            } else {
                setFormData((prevObject) => ({
                    ...prevObject,
                    hotel_country: "",
                }));
            }
            let state = [...StateList]
            if (dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('state') && dataSet.OrgMetaRelation.state && dataSet.OrgMetaRelation.state != "" && StateList) {
                let stateListFilter = StateList.filter((el) => {
                    return el.label.toLowerCase() == dataSet.OrgMetaRelation.state.toLowerCase();
                });
                if (stateListFilter.length > 0) {
                    setFormData((prevObject) => ({
                        ...prevObject,
                        hotel_state: stateListFilter[0].label.toLowerCase().toString(),
                    }));
                    setSelectedState(stateListFilter[0])
                }
            } else {
                setFormData((prevObject) => ({
                    ...prevObject,
                    hotel_state: "",
                }));
            }
            let city = [...CityList]
            if (dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('city') && dataSet.OrgMetaRelation.city && dataSet.OrgMetaRelation.city != "" && CityList) {
                let cityListFilter = CityList.filter((el) => {
                    return el.label.toLowerCase() == dataSet.OrgMetaRelation.city.toLowerCase();
                });
                if (cityListFilter.length > 0) {
                    let selectCity = { ...cityListFilter[0], 'value': cityListFilter[0].label }
                    setSelectedCity(cityListFilter && cityListFilter.length > 0 ? selectCity : "")
                    setFormData((prevObject) => ({
                        ...prevObject,
                        hotel_city: cityListFilter[0].label.toLowerCase().toString(),
                    }));
                }
            } else {
                setFormData((prevObject) => ({
                    ...prevObject,
                    hotel_city: "",
                }));
            }

            setAddHotelImagePreviewShow(dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('org_logo') && dataSet.OrgMetaRelation.org_logo != null && dataSet.OrgMetaRelation.org_logo != "" ? true : false)
            setSelectedCountry(countryListFilter[0])
            setAddHotelImageSelected(dataSet.hasOwnProperty('OrgMetaRelation') && dataSet.OrgMetaRelation && dataSet.OrgMetaRelation.hasOwnProperty('org_logo') && dataSet.OrgMetaRelation.org_logo != null && dataSet.OrgMetaRelation.org_logo != "" ? JSON.parse(dataSet.OrgMetaRelation.org_logo).file_obj : require('../Utility/Public/images/hotel.png'))

            if (timezonesArray && timezonesArray.length > 0) {
                let selectTimezone = timezonesArray.filter((el) => {
                    return el.value === dataSet?.OrgMetaRelation?.time_zone;
                });
                if (selectTimezone) {
                    setFormData((prevObject) => ({
                        ...prevObject,
                        selectedTimezone: selectTimezone[0],
                    }));
                }
            }
            
            // Set max_branch from dataSet
            if (dataSet.hasOwnProperty('max_branch') && dataSet.max_branch != null) {
                setFormData((prevObject) => ({
                    ...prevObject,
                    max_branch: dataSet.max_branch.toString(),
                }));
            }
        }
        setHotelCreateModalFlag(true)
    }

    //hotel active inactive button onchange fn
    const handleChangeSwitchButton = (data) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let dataHash = {};
        let id = data.id
        dataHash["is_active"] = data.is_active ? false : true;
        loaderStateTrue()
        hotelStatusUpdate(id, dataHash).then((response) => {
            if (response) {
                if (response.success) {
                    gridOptions.api.purgeInfiniteCache();
                    Utility.toastNotifications(response.message, "Success", "success");
                    resetDataGrid();
                } else {
                    gridOptions.api.purgeInfiniteCache();
                    Utility.toastNotifications(response.message, "Error", "error");
                    resetDataGrid();
                }
                loaderStateFalse()
            }
        }).catch((error) => {
            if (error) {
            }
            loaderStateFalse();
            if (error.message == "Network Error") {
            }
        });

    }

    //active inactive status filter onchange fn 
    const handleChangeUserFilter = (type, event) => {
        if (type == 'status') {
            if (event) {
                setSelectedStatus(event)
            } else {
                setSelectedStatus("")
            }
        }
    }

    useEffect(() => {
        if (gridApi && selectedStatus != "" && selectedStatus.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && selectedStatus == "") {
            resetDataGrid();
        }
    }, [selectedStatus])

    //reset state , city ,counry list
    const initiallyCuntryStateCitySelect = (country = "IN", state = "") => {
        getCountryOption();
        getCountryOptionForAgency();
        setSelectedCountryCode("in")
        setSelectedCountryCodeForAgency("in")
        getStateOption(country);
        getStateOptionForAgency(country);
        setSelectedState({});
        setSelectedStateForAgency({});
        setCityList([]);
        setCityListForAgency([]);
        setSelectedCity('');
        setSelectedCityForAgency('');
    }

    //create hotel modal fn
    const createHotelModalFn = () => {
        getVersionListApi();
        initiallyCuntryStateCitySelect();
        setHotelCreateModalFlag(true);
        setHotelModalTitle("Add Organization")
        setCityList([]);
    }

    const getVersionListApi = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        versionListApi().then((response) => {
            let versionList = [];
            let versionListObj = {};
            response.data.map((e) => {
                versionListObj = {};
                versionListObj['label'] = `${e.version} ${e.hasOwnProperty('description') && e.description && e.description != "" ? `( ${e.description} )` : ''}`;
                versionListObj['value'] = e.id;
                versionListObj['id'] = e.id;
                versionList.push(versionListObj)
            })
            if (versionList.length > 0) {
                setVersionList(versionList);
            }

            loaderStateFalse();
        }).catch((error) => {
            console.error("************error*************", error)
            if (error) {
            }
            loaderStateFalse();
            if (error.message == "Network Error") {
            }
        });
    }

    //close Hotel modal fn
    const closeHotelModal = () => {
        setHotelCreateModalFlag(false);
        resetFromData();
        setZoominzoomoutflag("")
        setHotelModalTitle("")
        setSelectedCountry({ "label": "India", "value": "india", "country_code": "91", "iso_code": "IN" })
        setSelectedCountryCode("in")
        setPhoneNumberCountryCode("in")
        setPhoneNumberDialCode("91")
        setPhoneNumberCountryCodeAdmin("in");
        setPhoneNumberDialCodeAdmin("91");
        setSelectedCountryForAgency({ "label": "India", "value": "india", "country_code": "91", "iso_code": "IN" })
        setSelectedCountryCodeForAgency("in")
        setPhoneNumberCountryCodeForAgency("in")
        setPhoneNumberDialCodeForAgency("91")
    }

    //reset Hotel modal fields fn
    const resetFromData = () => {
        setIsCheckedAgent(false);
        setFormData({
            "hotel_name": "",
            "hotel_email": "",
            "hotel_contact_number": "",
            "hotel_address1": "",
            "hotel_address2": "",
            "hotel_city": "",
            "hotel_state": "",
            "hotel_zip_code": "",
            "hotel_country": "india",
            "hotel_gstin_number": "",
            "hotel_pan_number": "",
            "first_name": "",
            "last_name": "",
            "email": "",
            "contact_number": "",
            "profile_image": "",
            "selectedTimezone": "",
            "max_branch": "",
            "version": "",
            "is_standalone": false,
            "is_mfa_required": false,
            "domain": "",
            "is_multi_threaded": 'singleThread',
            "agency_name_agent": "",
            "agency_name": "",
            "agency_image": "",
            "agency_email": "",
            "agency_address1": "",
            "agency_address2": "",
            "agency_zipcode": "",
            "agency_country": "india",
            "agency_contact_number": "",
            "agency_state": "",
            "agency_city": "",
            "agency_gstin_number": "",
            "agency_pan_number": "",
            "allow_main_store": false,
            "is_waliner_enabled":false,
        })
        setErrorFormData({
            "hotel_name": "",
            "hotel_email": "",
            "hotel_contact_number": "",
            "hotel_address1": "",
            "hotel_address2": "",
            "hotel_city": "",
            "hotel_state": "",
            "hotel_zip_code": "",
            "hotel_country": "",
            "hotel_gstin_number": "",
            "hotel_pan_number": "",
            "first_name": "",
            "last_name": "",
            "email": "",
            "contact_number": "",
            "profile_image": "",
            "selectedTimezone": "",
            "max_branch": "",
            "version": "",
            "is_standalone": false,
            "domain": "",
            "is_multi_threaded": "",
            "agency_name_agent": "",
            "agency_name": "",
            "agency_image": "",
            "agency_email": "",
            "agency_address1": "",
            "agency_address2": "",
            "agency_zipcode": "",
            "agency_country": "",
            "agency_contact_number": "",
            "agency_state": "",
            "agency_city": "",
            "agency_gstin_number": "",
            "agency_pan_number": "",
            "allow_main_store": "",
            "is_waliner_enabled":""
        })
        setSelectedVersion({})
        setAddProfileImagePreviewShow(false)
        setImageCropModalFlag(false)
        setSrc(null)
        setAddprofileImageSelected(require('../Utility/Public/images/profile-back.png'))
        setCrop({
            unit: '%',
            width: 30,
        })
        setCroppedImageUrl("")
        //agency image flag
        setAddHotelImagePreviewShow(false)
        setHotelImageCropModalFlag(false)
        setHotelSrc(null);
        setAddHotelImageSelected(require('../Utility/Public/images/hotel.png'))
        setHotelCrop({
            unit: '%',
            width: 30,
        })
        setHotelCroppedImageUrl("")
        //edited falg
        setEditedHotelFlag(false)
        setEditedHotelId("")
        setEditedAdminId("")
        setEditRowData({})
        setSelectedCountry({ "label": "India", "value": "india", "country_code": "91", "iso_code": "IN" })
        setSelectedCountryCode("in")
        setSelectedCountryForAgency({ "label": "India", "value": "india", "country_code": "91", "iso_code": "IN" })
        setSelectedCountryCodeForAgency("in")

    }

    //hotel add form fields handlechange function
    const handelChange = (e, type, countryCode = {}) => {
        let tempFormData = { ...formData };
        let tempErrorFormData = { ...errorFormData }
        if (type == "hotel_name") {
            if (e.target.value == "") {
                tempErrorFormData['hotel_name'] = ""
                tempFormData["hotel_name"] = ""
            } else {
                tempFormData["hotel_name"] = e.target.value
                tempErrorFormData['hotel_name'] = ""
            }
        }
        if (type == "hotel_email") {
            if (e.target.value != "") {
                let emailValidate = ValidateUtility.validate_email(e.target.value);
                if (emailValidate) {
                    tempFormData["hotel_email"] = e.target.value
                    tempErrorFormData['hotel_email'] = ""
                } else {
                    tempFormData["hotel_email"] = e.target.value
                    tempErrorFormData['hotel_email'] = "Enter valid email"
                }
            } else {
                tempFormData["hotel_email"] = ""
                tempErrorFormData['hotel_email'] = ""
            }
        }

        if (type == "hotel_contact_number") {
            if (e.trim() !== "") {
                let modifiedString = ValidateUtility.deleteAndBefore(e, countryCode.dialCode);
                let countryCodeValue = countryCode.countryCode.toUpperCase();
                const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
                setPhoneNumberCountryCode(countryCode.countryCode)
                setPhoneNumberDialCode(countryCode.dialCode)
                if (phoneNumber && phoneNumber.isValid()) {
                    tempFormData["hotel_contact_number"] = e
                    tempErrorFormData['hotel_contact_number'] = ""
                } else {
                    tempFormData["hotel_contact_number"] = e
                    tempErrorFormData['hotel_contact_number'] = "Enter valid phone number"
                }
            } else {
                tempFormData["hotel_contact_number"] = "";
                tempErrorFormData['hotel_contact_number'] = "Required field";
            }
        }
        if (type == "hotel_address1") {
            if (e.target.value == "") {
                tempErrorFormData['hotel_address1'] = ""
                tempFormData["hotel_address1"] = ""
            } else {
                tempFormData["hotel_address1"] = e.target.value
                tempErrorFormData['hotel_address1'] = ""
            }
        }
        if (type == "hotel_address2") {
            if (e.target.value == "") {
                tempErrorFormData['hotel_address2'] = ""
                tempFormData["hotel_address2"] = ""
            } else {
                tempFormData["hotel_address2"] = e.target.value
                tempErrorFormData['hotel_address2'] = ""
            }
        }

        if (type == "hotel_zip_code") {
            var expr = /^[0-9]*$/;
            if (!expr.test(e.target.value)) {
            } else {
                if (e.target.value == "") {
                    tempErrorFormData['hotel_zip_code'] = ""
                    tempFormData["hotel_zip_code"] = ""
                } else {
                    tempFormData["hotel_zip_code"] = e.target.value
                    tempErrorFormData['hotel_zip_code'] = ""
                }
            }
        }
        if (type == "hotel_country") {

            if (e) {
                if (selectedCountryCode.toLowerCase().toString() != e.label.toLowerCase().toString()) {
                    // Set blank value on State
                    tempFormData["hotel_state"] = ""
                    tempErrorFormData['hotel_state'] = ""
                    // Set blank value on City
                    tempFormData["hotel_city"] = ""
                    tempErrorFormData['hotel_city'] = ""

                    tempErrorFormData['hotel_country'] = ""
                    tempFormData["hotel_country"] = e.label.toLowerCase()
                    setSelectedCountry(e)
                    setSelectedCountryCode(e.value.toLowerCase().toString())
                    tempFormData["hotel_contact_number"] = ""

                    setSelectedState({});
                    setStateList([]);
                    setSelectedCity('');
                    setCityList([]);
                    getStateOption(e.iso_code.toString())
                }
            } else {
                // Set blank value on State
                tempFormData["hotel_state"] = ""
                tempErrorFormData['hotel_state'] = ""
                // Set blank value on City
                tempFormData["hotel_city"] = ""
                tempErrorFormData['hotel_city'] = ""

                tempFormData["hotel_country"] = ""
                tempErrorFormData['hotel_country'] = ""
                tempFormData["hotel_contact_number"] = ""
                setSelectedCountry({ "label": "India", "value": "india" })
                setSelectedCountryCode("in")
            }
        }

        if (type == "hotel_state") {
            // Set blank value on City
            tempFormData["hotel_city"] = ""
            tempErrorFormData['hotel_city'] = ""
            if (e) {
                tempFormData["hotel_state"] = e.label.toLowerCase()
                tempErrorFormData['hotel_state'] = ""
                setCityList([]);
                setSelectedState(e)
                setSelectedCity('');
                getCityOption(e.value, e.country_id)
            } else {
                tempErrorFormData['hotel_state'] = ""
                tempFormData["hotel_state"] = ""
            }
        }

        if (type == "hotel_city") {
            if (e) {
                tempFormData["hotel_city"] = e.label.toLowerCase()
                tempErrorFormData['hotel_city'] = ""
                setSelectedCity(e)
            } else {
                tempErrorFormData['hotel_city'] = ""
                tempFormData["hotel_city"] = ""
                setSelectedCity('')
            }
        }

        if (type == "hotel_gstin_number") {
            if (e.target.value == "") {
                tempErrorFormData['hotel_gstin_number'] = ""
                tempFormData["hotel_gstin_number"] = ""
            } else {
                let gstnValidate = ValidateUtility.validate_gstn_Number(e.target.value);
                if (gstnValidate) {
                    tempFormData["hotel_gstin_number"] = e.target.value.toUpperCase()
                    tempErrorFormData['hotel_gstin_number'] = ""

                } else {
                    tempFormData["hotel_gstin_number"] = e.target.value.toUpperCase()
                    tempErrorFormData['hotel_gstin_number'] = `${props.t('validgstnnumber')}`
                }
            }
        }

        if (type == "hotel_pan_number") {
            if (e.target.value == "") {
                tempFormData['hotel_pan_number'] = "";
                tempErrorFormData['hotel_pan_number'] = ""
            } else {
                let panValidate = ValidateUtility.validate_pan_Number(e.target.value);
                if (panValidate) {
                    tempFormData['hotel_pan_number'] = e.target.value.toUpperCase();
                    tempErrorFormData['hotel_pan_number'] = ""

                } else {
                    tempFormData['hotel_pan_number'] = e.target.value.toUpperCase();
                    tempErrorFormData['hotel_pan_number'] = props.t('validpannumber')
                }
            }
        }

        if (type == "first_name") {
            var expr = /^[a-zA-Z0-9 ]*$/;
            if (!expr.test(e.target.value)) {

            } else {
                if (e.target.value == "") {
                    tempErrorFormData['first_name'] = ""
                    tempFormData["first_name"] = ""
                } else {
                    tempFormData["first_name"] = e.target.value
                    tempErrorFormData['first_name'] = ""
                }
            }
        }
        if (type == "last_name") {
            var expr = /^[a-zA-Z0-9 ]*$/;
            if (!expr.test(e.target.value)) {

            } else {
                if (e.target.value == "") {
                    tempErrorFormData['last_name'] = ""
                    tempFormData["last_name"] = ""
                } else {
                    tempFormData["last_name"] = e.target.value
                    tempErrorFormData['last_name'] = ""
                }
            }
        }

        if (type == "email") {
            if (e.target.value != "") {
                let emailValidate = ValidateUtility.validate_email(e.target.value);
                if (emailValidate) {
                    tempFormData["email"] = e.target.value,
                        tempErrorFormData['email'] = ""
                } else {
                    tempFormData["email"] = e.target.value,
                        tempErrorFormData['email'] = "Enter valid email"
                }
            } else {
                tempFormData["email"] = "",
                    tempErrorFormData['email'] = ""
            }
        }

        if (type == "contact_number") {
            if (e.trim() !== "") {
                let modifiedString = ValidateUtility.deleteAndBefore(e, countryCode.dialCode);
                let countryCodeValue = countryCode.countryCode.toUpperCase();
                const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
                setPhoneNumberCountryCodeAdmin(countryCode.countryCode)
                setPhoneNumberDialCodeAdmin(countryCode.dialCode)
                if (phoneNumber && phoneNumber.isValid()) {
                    tempFormData["contact_number"] = e
                    tempErrorFormData['contact_number'] = ""
                } else {
                    tempFormData["contact_number"] = e
                    tempErrorFormData['contact_number'] = "Enter valid phone number"
                }
            } else {
                tempFormData["contact_number"] = "";
                tempErrorFormData['contact_number'] = "Required field";
            }
        }

        if (type == "bank_name") {
            if (e.target.value == "") {
                tempErrorFormData['bank_name'] = ""
                tempFormData["bank_name"] = ""
            } else {
                tempFormData["bank_name"] = e.target.value
                tempErrorFormData['bank_name'] = ""
            }
        }
        if (type == "branch") {
            if (e.target.value == "") {
                tempErrorFormData['branch'] = ""
                tempFormData["branch"] = ""
            } else {
                tempFormData["branch"] = e.target.value
                tempErrorFormData['branch'] = ""
            }
        }

        if (type == "hotel_timezone") {
            tempErrorFormData['selectedTimezone'] = ""
            tempFormData["selectedTimezone"] = e
        }

        if (type == "max_branch") {
            if (e.target.value == "") {
                tempErrorFormData['max_branch'] = ""
                tempFormData["max_branch"] = ""
            } else {
                const value = e.target.value;
                // Only allow positive integers
                if (/^\d*$/.test(value) && parseInt(value) >= 0) {
                    tempFormData["max_branch"] = value
                    tempErrorFormData['max_branch'] = ""
                } else {
                    tempFormData["max_branch"] = value
                    tempErrorFormData['max_branch'] = "Please enter a valid positive number"
                }
            }
        }

        if (type == 'version') {
            if (e) {
                tempFormData["version"] = e.value;
                tempErrorFormData['version'] = "";
                setSelectedVersion(e)
                if (e.value != 'v4') {
                    tempFormData["is_mfa_required"] = false;
                    tempFormData["agency_mfa_required"] = false;
                }
            } else {
                tempFormData["version"] = "";
                tempErrorFormData['version'] = "";
                setSelectedVersion({})

            }
        }

        if (type == 'is_standalone') {
            if (e) {
                tempFormData["is_standalone"] = e.target.checked;
                tempErrorFormData['is_standalone'] = "";
            } else {
                tempFormData["is_standalone"] = false;
                tempErrorFormData['is_standalone'] = "";

            }
        }
        if (type == 'is_mfa_required') {
            if (e) {
                tempFormData["is_mfa_required"] = e.target.checked;
                tempErrorFormData['is_mfa_required'] = "";
            } else {
                tempFormData["is_mfa_required"] = false;
                tempErrorFormData['is_mfa_required'] = "";

            }
        }
        if (type == 'allow_main_store') {
            if (e) {
                tempFormData["allow_main_store"] = e.target.checked;
                tempErrorFormData['allow_main_store'] = "";
            } else {
                tempFormData["allow_main_store"] = false;
                tempErrorFormData['allow_main_store'] = "";

            }
        }
        if (type == 'is_waliner_enabled') {
            if (e) {
                tempFormData["is_waliner_enabled"] = e.target.checked;
                tempErrorFormData['is_waliner_enabled'] = "";
            } else {
                tempFormData["is_waliner_enabled"] = false;
                tempErrorFormData['is_waliner_enabled'] = "";

            }
        }
        if (type == 'agency_mfa_required') {
            if (e) {
                tempFormData["agency_mfa_required"] = e.target.checked;
            } else {
                tempFormData["agency_mfa_required"] = false;
            }
        }
        if (type == 'is_agency') {
            if (e) {
                tempFormData["is_agency"] = e.target.checked;
            } else {
                tempFormData["is_agency"] = false;
            }
        }
        if (type == "domain") {
            if (e.target.value == "") {
                tempErrorFormData['domain'] = ""
                tempFormData["domain"] = ""
            } else {
                tempFormData["domain"] = e.target.value
                tempErrorFormData['domain'] = ""
            }
        }
        if (type == "multiThread") {
            tempErrorFormData['is_multi_threaded'] = ''
            tempFormData["is_multi_threaded"] = "multiThread"
        }
        if (type == "singleThread") {
            tempErrorFormData['is_multi_threaded'] = ''
            tempFormData["is_multi_threaded"] = "singleThread"
        }
        if (type == "registerHotelRepresentative") {
            tempErrorFormData['is_multi_threaded'] = ''
            tempFormData["is_multi_threaded"] = "registerHotelRepresentative"
        }

        //Agency details start===================
        if (type == "agency_name") {
            if (e.target.value == "") {
                tempErrorFormData['agency_name'] = ""
                tempFormData["agency_name"] = ""
            } else {
                tempFormData["agency_name"] = e.target.value
                tempErrorFormData['agency_name'] = ""
            }
        }
        if (type == "agency_email") {
            if (e.target.value != "") {
                let emailValidate = ValidateUtility.validate_email(e.target.value);
                if (emailValidate) {
                    tempFormData["agency_email"] = e.target.value
                    tempErrorFormData['agency_email'] = ""
                } else {
                    tempFormData["agency_email"] = e.target.value
                    tempErrorFormData['agency_email'] = "Enter valid email"
                }
            } else {
                tempFormData["agency_email"] = ""
                tempErrorFormData['agency_email'] = ""
            }
        }
        if (type == "agency_contact_number") {
            if (e.trim() !== "") {
                let modifiedString = ValidateUtility.deleteAndBefore(e, countryCode.dialCode);
                let countryCodeValue = countryCode.countryCode.toUpperCase();
                const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
                setPhoneNumberCountryCodeForAgency(countryCode.countryCode)
                setPhoneNumberDialCodeForAgency(countryCode.dialCode)
                if (phoneNumber && phoneNumber.isValid()) {
                    tempFormData["agency_contact_number"] = e
                    tempErrorFormData['agency_contact_number'] = ""
                } else {
                    tempFormData["agency_contact_number"] = e
                    tempErrorFormData['agency_contact_number'] = "Enter valid phone number"
                }
            } else {
                tempFormData["agency_contact_number"] = "";
                tempErrorFormData['agency_contact_number'] = "Required field";
            }
        }

        if (type == "agency_address1") {
            if (e.target.value == "") {
                tempErrorFormData['agency_address1'] = ""
                tempFormData["agency_address1"] = ""
            } else {
                tempFormData["agency_address1"] = e.target.value
                tempErrorFormData['agency_address1'] = ""
            }
        }
        if (type == "agency_address2") {
            if (e.target.value == "") {
                tempErrorFormData['agency_address2'] = ""
                tempFormData["agency_address2"] = ""
            } else {
                tempFormData["agency_address2"] = e.target.value
                tempErrorFormData['agency_address2'] = ""
            }
        }
        if (type == "agency_zipcode") {
            var expr = /^[0-9]*$/;
            if (!expr.test(e.target.value)) {
            } else {
                if (e.target.value == "") {
                    tempErrorFormData['agency_zipcode'] = ""
                    tempFormData["agency_zipcode"] = ""
                } else {
                    tempFormData["agency_zipcode"] = e.target.value
                    tempErrorFormData['agency_zipcode'] = ""
                }
            }
        }
        if (type == "agency_country") {

            if (e) {
                if (selectedCountryCodeForAgency.toLowerCase().toString() != e.label.toLowerCase().toString()) {
                    // Set blank value on State
                    tempFormData["agency_state"] = ""
                    tempErrorFormData['agency_state'] = ""
                    // Set blank value on City
                    tempFormData["agency_city"] = ""
                    tempErrorFormData['agency_city'] = ""

                    tempErrorFormData['agency_country'] = ""
                    tempFormData["agency_country"] = e.label.toLowerCase()
                    setSelectedCountryForAgency(e)
                    setSelectedCountryCodeForAgency(e.value.toLowerCase().toString())
                    tempFormData["agency_contact_number"] = ""

                    setSelectedStateForAgency({});
                    setStateListForAgency([]);
                    setSelectedCityForAgency('');
                    setCityListForAgency([]);
                    getStateOptionForAgency(e.iso_code.toString())
                }
            } else {
                // Set blank value on State
                tempFormData["agency_state"] = ""
                tempErrorFormData['agency_state'] = ""
                // Set blank value on City
                tempFormData["agency_city"] = ""
                tempErrorFormData['agency_city'] = ""

                tempFormData["agency_country"] = ""
                tempErrorFormData['agency_country'] = ""
                tempFormData["agency_contact_number"] = ""
                setSelectedCountryForAgency({ "label": "India", "value": "india" })
                setSelectedCountryCodeForAgency("in")
            }
        }

        if (type == "agency_state") {
            // Set blank value on City
            tempFormData["agency_city"] = ""
            tempErrorFormData['agency_city'] = ""
            if (e) {
                tempFormData["agency_state"] = e.label.toLowerCase()
                tempErrorFormData['agency_state'] = ""
                setCityListForAgency([]);
                setSelectedStateForAgency(e)
                setSelectedCityForAgency('');
                getCityOptionForAgency(e.value, e.country_id)
            } else {
                tempErrorFormData['agency_state'] = ""
                tempFormData["agency_state"] = ""
            }
        }

        if (type == "agency_city") {
            if (e) {
                tempFormData["agency_city"] = e.label.toLowerCase()
                tempErrorFormData['agency_city'] = ""
                setSelectedCityForAgency(e)
            } else {
                tempErrorFormData['agency_city'] = ""
                tempFormData["agency_city"] = ""
                setSelectedCityForAgency('')
            }
        }

        if (type == "agency_gstin_number") {
            if (e.target.value == "") {
                tempErrorFormData['agency_gstin_number'] = ""
                tempFormData["agency_gstin_number"] = ""
            } else {
                let gstnValidate = ValidateUtility.validate_gstn_Number(e.target.value);
                if (gstnValidate) {
                    tempFormData["agency_gstin_number"] = e.target.value.toUpperCase()
                    tempErrorFormData['agency_gstin_number'] = ""

                } else {
                    tempFormData["agency_gstin_number"] = e.target.value.toUpperCase()
                    tempErrorFormData['agency_gstin_number'] = `${props.t('validgstnnumber')}`
                }
            }
        }

        if (type == "agency_pan_number") {
            if (e.target.value == "") {
                tempFormData['agency_pan_number'] = "";
                tempErrorFormData['agency_pan_number'] = ""
            } else {
                let panValidate = ValidateUtility.validate_pan_Number(e.target.value);
                if (panValidate) {
                    tempFormData['agency_pan_number'] = e.target.value.toUpperCase();
                    tempErrorFormData['agency_pan_number'] = ""

                } else {
                    tempFormData['agency_pan_number'] = e.target.value.toUpperCase();
                    tempErrorFormData['agency_pan_number'] = props.t('validpannumber')
                }
            }
        }
        //Agency details end===================

        setFormData(tempFormData)
        setErrorFormData(tempErrorFormData)
    }

    useEffect(() => {
    }, [selectedVersion])


    //when hoetel grid call from dashboard page
    useEffect(() => {
        if (!props.hotelFilterShow) {
            hideColumn();
        }
    }, [])

    //set aggrid columndef
    const hideColumn = () => {
        let columnDefs = [
            {
                headerName: "",
                field: "profile_img_temp",
                maxWidth: 72,
                cellRenderer: (params) => {
                    if (params && params.data) {
                        if (params.data) {
                            return <div className="gridusericon">
                                <img src={require('../Utility/Public/images/hotel-img.png')} />
                            </div>
                        } else {
                            return <img src="https://www.ag-grid.com/example-assets/loading.gif" />
                        }
                    } else {
                        return <img src="https://www.ag-grid.com/example-assets/loading.gif" />
                    }
                }
            },
            {
                headerName: 'Organization Name',
                field: "",
                minWidth: 250,
                cellRenderer: (params) => {
                    if (params.data) {
                        let concatname = params.data.org_name
                        if (params.data.org_name && concatname.length > 15) {
                            return <div className="usercursor"><span className="textrenderview">
                                <OverlayTrigger overlay={<Tooltip>{params.data && params.data.org_name != "" ? params.data.org_name : ""}</Tooltip>}>
                                    <span >
                                        {params.data && params.data.org_name != "" ? params.data.org_name : ""}
                                    </span>
                                </OverlayTrigger>
                            </span></div>
                        } else {
                            return (<div className="usercursor"><span className="textrenderview">{params.data && params.data.org_name != "" ? params.data.org_name : ""}</span></div>)
                        }

                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Admin',
                field: "email",
                minWidth: 200,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('OrgUserRelation') && params.data.OrgUserRelation[0]) {
                            if (params.data.OrgUserRelation[0].hasOwnProperty('UserOrgBranchRoleRelation') && params.data.OrgUserRelation[0].UserOrgBranchRoleRelation) {
                                return <div className="usercursor"><span className="textrenderview">
                                    <OverlayTrigger overlay={<Tooltip>{params.data.OrgUserRelation[0].UserOrgBranchRoleRelation.email}</Tooltip>}>
                                        <span >{params.data.OrgUserRelation[0].UserOrgBranchRoleRelation.email}</span>
                                    </OverlayTrigger>
                                </span></div>
                            } else {
                                return null;
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
        ]

        setColumnDefs(columnDefs)
    }

    //<================admin profile image function start=================>
    //admin profile image onclick fn
    const addInputProfileImageChanged = (event) => {
        let tempFormData = { ...formData };
        let tempErrorFormData = { ...errorFormData }
        let targetFileSplit = event.target.files[0].name.split('.');
        let lastElement = targetFileSplit.pop();
        let user_profile_image = {
            "file_name": "",
            "file_obj": ""
        };
        const file = event.target.files[0];
        const allowedTypes = Utility.acceptFileType();
        Utility.checkFileType(file, allowedTypes)
            .then(results => {
                if (results.isValid) {
                    const fsize = event.target.files[0].size;
                    const file = Math.round((fsize / 1024));
                    if (file >= 300) {
                        Utility.toastNotifications(props.t('imageUploadAlert'), "Warning", "warning");
                    } else {
                        setImageCropModalFlag(true)
                        if (event.target.files && event.target.files.length > 0) {
                            const reader = new FileReader();
                            reader.addEventListener('load', () =>
                                setSrc(reader.result)
                            );
                            reader.readAsDataURL(event.target.files[0]);
                            user_profile_image["file_name"] = event.target.files[0].name
                            user_profile_image["file_obj"] = ""
                            tempFormData['profile_image'] = user_profile_image
                            tempErrorFormData['profile_image'] = ""
                            setAddProfileImagePreviewShow(true)
                        }
                    }
                } else {
                    Utility.toastNotifications(`Please choose jpg , jpeg or png format.`, "Warning", "warning")
                    tempFormData['profile_image'] = "";
                    setAddProfileImagePreviewShow(false)
                    setAddprofileImageSelected('')
                }
            })
            .catch(error => {
                console.error("Error:", error);

            });
        setFormData(tempFormData)
        setErrorFormData(tempErrorFormData)
    }

    const onImageLoaded = (image) => {
        if (image) {
            imageRef.current = image
        }
    };
    //when hit crop button on crop image modal
    const onCropComplete = (crop) => {
        makeClientCrop(crop);
    };

    //when select the crop area 
    const onCropChange = (crop, percentCrop) => {
        setCrop(crop)
    };

    //crop image from main image
    const makeClientCrop = async (crop) => {
        let tempFormData = { ...formData };
        if (imageRef && crop.width && crop.height) {
            const croppedImageUrl = await getCroppedImg(
                imageRef.current,
                crop,
                'newFile.jpeg'
            );
            let user_profile_image = {}
            setAddprofileImageSelected(croppedImageUrl)
            user_profile_image["file_name"] = formData.profile_image.file_name
            user_profile_image["file_obj"] = croppedImageUrl
            tempFormData["profile_image"] = user_profile_image

            setFormData(tempFormData)

        }
    }

    //create a canvas of crop image from original image
    const getCroppedImg = (image, crop, fileName) => {
        const canvas = document.createElement('canvas');
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        const base64Image = canvas.toDataURL('image/jpeg');
        return base64Image
    }

    //crop image modal show fn
    const imageCropModalShow = () => {
        setImageCropModalFlag(true)
    }

    //crop image modal close fn
    const imageCropModalHide = () => {
        formData['profile_image'] = "",
            errorFormData['profile_image'] = "",
            setImageCropModalFlag(false)
        setAddprofileImageSelected(require('../Utility/Public/images/profile-back.png'))
        setAddProfileImagePreviewShow(false),
            setSrc(null),
            setCrop({
                unit: '%',
                width: 30,
            }),
            setCroppedImageUrl("")
    }

    const imageCropDataSave = () => {
        setImageCropModalFlag(false)
    }

    //<================profile image function end=================>

    //<================agency image function start=================>
    //agency image upload onchange fn
    const addInputHotelImageChanged = (event) => {
        let targetFileSplit = event.target.files[0].name.split('.');
        let lastElement = targetFileSplit.pop();
        let agency_image_data = {
            "file_name": "",
            "file_obj": ""
        };
        if (lastElement == 'JPEG' || lastElement == 'jpeg' || lastElement == 'jpg' || lastElement == 'JPG' || lastElement == 'png' || lastElement == 'PNG') {
            const fsize = event.target.files[0].size;
            const file = Math.round((fsize / 1024));
            if (file >= 300) {
                Utility.toastNotifications(props.t('imageUploadAlert'), "Warning", "warning");
            } else {
                setHotelImageCropModalFlag(true)
                if (event.target.files && event.target.files.length > 0) {
                    const reader = new FileReader();
                    reader.addEventListener('load', () =>
                        setHotelSrc(reader.result)
                    );
                    reader.readAsDataURL(event.target.files[0]);
                    agency_image_data["file_name"] = event.target.files[0].name
                    agency_image_data["file_obj"] = ""
                    formData['agency_image'] = agency_image_data
                    errorFormData['agency_image'] = ""
                    setAddHotelImagePreviewShow(true)
                }
            }

        } else {
            formData['agency_image'] = ""
            errorFormData['agency_image'] = props.t('invalidLogo')
            setAddHotelImagePreviewShow(false)
            setAddHotelImageSelected('')
            Utility.toastNotifications("File format is not supported, it should be in jpg, jpeg or png format", "Warning", "warning");
        }
    }
    //create a image ref of uploaded agency image
    const onHotelImageLoaded = (image) => {
        if (image) {
            hotelImageRef.current = image
        }
    };
    //after hit crop button on crop image modal
    const onHotelCropComplete = (crop) => {
        makeClientCropHotel(crop);
    };

    //select crop area onchage
    const onCropChangeHotel = (crop, percentCrop) => {
        setHotelCrop(crop)
    };


    //crop image from original image
    const makeClientCropHotel = async (crop) => {
        if (hotelImageRef && crop.width && crop.height) {
            const hotelCroppedImageUrl = await getHotelCroppedImg(
                hotelImageRef.current,
                crop,
                'newFile.jpeg'
            );
            let agency_image_data = {}
            setAddHotelImageSelected(hotelCroppedImageUrl)
            agency_image_data["file_name"] = formData.agency_image.file_name
            agency_image_data["file_obj"] = hotelCroppedImageUrl
            formData["agency_image"] = agency_image_data
        }
    }
    //create a canvas of cropped image and create a new image 
    const getHotelCroppedImg = (image, crop, fileName) => {
        const canvas = document.createElement('canvas');
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        const base64Image = canvas.toDataURL('image/jpeg');
        return base64Image
    }

    //agency image crop modal show
    const hotelImageCropModalShow = () => {
        setHotelImageCropModalFlag(true)
    }

    //agency crop image close fn
    const hotelImageCropModalHide = () => {
        formData['agency_image'] = "",
            errorFormData['agency_image'] = "",
            setHotelImageCropModalFlag(false)
        setAddHotelImageSelected(require('../Utility/Public/images/hotel.png'))
        setAddHotelImagePreviewShow(false),
            setHotelSrc(null),
            setHotelCrop({
                unit: '%',
                width: 30,
            }),
            setHotelCroppedImageUrl("")
    }

    //after successfully crop , set the crop image data
    const hotelImageCropDataSave = () => {
        setHotelImageCropModalFlag(false)
    }
    //<================hotel image function end=================>
    //formatting hotel creation and update dataset fn
    const formatingHotelDataset = () => {
        let dataset = [];
        let hash = {};
        let agency_hash = {};
        if (formData.hotel_name != "") {
            hash['org_name'] = formData.hotel_name.trim();
        }
        if (formData.hotel_email.trim() != "") {
            hash['email'] = formData.hotel_email.trim();
        }
        if (formData.hotel_contact_number != "") {
            hash['contact_number'] = formData.hotel_contact_number;
        }
        if (formData.hotel_address1 != "") {
            hash['address1'] = formData.hotel_address1;
        }
        if (formData.hotel_address2 != "" && formData.hotel_address2 != null) {
            hash['address2'] = formData.hotel_address2.trim();
        } else {
            hash['address2'] = "";
        }
        if (formData.hotel_city != "") {
            hash['city'] = formData.hotel_city.trim();
        }
        if (formData.hotel_state != "") {
            hash['state'] = formData.hotel_state.trim();
        }
        if (formData.hotel_zip_code != "") {
            hash['zip'] = formData.hotel_zip_code.trim();
        }
        if (formData.hotel_country != "") {
            hash['country'] = formData.hotel_country.trim();
        }
        if (formData.hotel_gstin_number != "") {
            hash['gstin_number'] = formData.hotel_gstin_number.trim();
        } else {
            hash['gstin_number'] = ""
        }
        if (formData.hotel_pan_number != "") {
            hash['pan_number'] = formData.hotel_pan_number.trim();
        } else {
            hash['pan_number'] = ""
        }
        if (formData.selectedTimezone != "") {
            hash['time_zone'] = formData.selectedTimezone.value;
        }

        if (formData.max_branch != "") {
            hash['max_branch'] = parseInt(formData.max_branch);
        }

        if (!editedHotelFlag) {
            hash['is_active'] = true
            // agency_hash['is_active'] = true
        } else {
            hash['is_active'] = editRowData.is_active ? editRowData.is_active = true : false
            // agency_hash['is_active'] = editRowData.is_active ? editRowData.is_active = true : false
        }
        if (formData.version) {
            hash["version_id"] = formData.version;
            // agency_hash["version_id"] = formData.version;
        }
        hash["is_standalone"] = true;
        hash["is_global"] = formData.is_standalone;
        hash["is_mfa_required"] = formData.is_mfa_required;
        hash["allow_main_store"] = formData.allow_main_store;
        hash["is_waliner_enabled"] = formData.is_waliner_enabled;
        hash["domain"] = (formData.domain).trim();

        if (formData.is_multi_threaded === 'singleThread') {
            hash["is_multi_threaded"] = 0;
        } else if (formData.is_multi_threaded === 'multiThread') {
            hash["is_multi_threaded"] = 1;
        } else if (formData.is_multi_threaded === 'registerHotelRepresentative') {
            hash["is_multi_threaded"] = 2;
        }
        // agency_hash['agency_included'] = isCheckedAgent;
        if (formData.is_agency) {
            hash['org_type'] = 'agent'
        }
        if (formData.agency_image != "") {
            hash['org_logo'] = formData.agency_image;
        }
        // if (isCheckedAgent) {
        //     agency_hash['is_mfa_required'] = formData.agency_mfa_required
        //     agency_hash['org_type'] = 'agent';
        //     if (formData.agency_name != "" && formData.agency_name != "undefined") {
        //         agency_hash['org_name'] = formData.agency_name.trim();
        //     }
        //     if (formData.agency_image != "") {
        //         agency_hash['org_logo'] = formData.agency_image;
        //     }
        //     if (formData.agency_email.trim() != "") {
        //         agency_hash['email'] = formData.agency_email.trim();
        //     }
        //     if (formData.agency_contact_number != "") {
        //         agency_hash['contact_number'] = formData.agency_contact_number;
        //     }
        //     if (formData.agency_address1 != "") {
        //         agency_hash['address1'] = formData.agency_address1;
        //     }
        //     if (formData.agency_address2 != "" && formData.agency_address2 != null) {
        //         agency_hash['address2'] = formData.agency_address2;
        //     } else {
        //         agency_hash['address2'] = "";
        //     }

        //     if (formData.agency_zipcode != "") {
        //         agency_hash['zip'] = formData.agency_zipcode;
        //     }
        //     if (formData.agency_country != "") {
        //         agency_hash['country'] = formData.agency_country;
        //     }
        //     if (formData.agency_state != "") {
        //         agency_hash['state'] = formData.agency_state;
        //     }
        //     if (formData.agency_city != "") {
        //         agency_hash['city'] = formData.agency_city;
        //     }
        //     if (formData.agency_gstin_number != "" && formData.agency_gstin_number != "undefined" && formData.agency_gstin_number != null) {
        //         agency_hash['gstin_number'] = formData.agency_gstin_number;
        //     } else {
        //         agency_hash['gstin_number'] = ""
        //     }
        //     if (formData.agency_pan_number != "" && formData.agency_pan_number != "undefined" && formData.agency_pan_number != null) {
        //         agency_hash['pan_number'] = formData.agency_pan_number;
        //     } else {
        //         agency_hash['pan_number'] = ""
        //     }
        // }

        dataset.push(hash)
        // if (Object.keys(agency_hash).length > 0) {
        //     dataset.push(agency_hash)
        // }
        return dataset;
    }

    //formatting admin creation and update dataset fn
    const formatingAdminDataset = (res) => {
        let dataset = [];
        let hash = {}
        if (formData.first_name != "") {
            hash['first_name'] = formData.first_name.trim();;
        }
        if (formData.last_name != "") {
            hash['last_name'] = formData.last_name.trim();;
        }
        if (formData.email.trim() != "") {
            hash['email'] = formData.email.trim();
        }
        var phoneNumber = formData.contact_number
        var plusRemovePhoneNumber = phoneNumber.replace(/\+/g, '')
        if (formData.contact_number != "") {
            hash['contact_number'] = plusRemovePhoneNumber;
        }

        if (formData.profile_image != "") {
            hash['profile_img_url'] = formData.profile_image != "" ? formData.profile_image : "";
        }

        let userTypeArr = [];
        let userTypeObj = {};
        if (res.length > 0) {
            res.forEach((item) => {
                if (item.success) {
                    userTypeObj = {};
                    userTypeObj['user_type'] = item.data.hasOwnProperty('org_type') ? item.data.org_type : "admin";
                    userTypeObj['org_id'] = item.data.id;
                    userTypeArr.push(userTypeObj)
                }
            });
        }

        hash['user_type'] = userTypeArr;
        // if (!editedHotelFlag) {
        //     hash['org_id'] = hotel_id;
        // }
        // if (agency_id != "") {
        //     hash['org_id'] = agency_id;
        // }

        // if (isCheckedAgent) {
        //     userTypeObj['user_type']
        //     userTypeArr.push(userTypeObj)
        // }
        //  hash['user_type'] = isCheckedAgent ? [{ "user_type": "admin",  }, { "user_type": "agent" }] : [{ "user_type": "admin" }]
        hash['is_active'] = true

        dataset.push(hash)
        return dataset;

    }

    //validate hotel create form data
    const validationFromData = () => {
        let tempFormData = { ...formData }
        let tempErrorFormData = { ...errorFormData }
        let valid = true

        let tempHotelName = tempFormData.hotel_name;
        let trimmedTempHotelName = tempHotelName.trim();
        if (trimmedTempHotelName == "") {
            tempErrorFormData['hotel_name'] = "Required field"
            valid = false
        }

        if (tempFormData.hotel_email.trim() == "" || tempFormData.hotel_email == null) {
            tempErrorFormData['hotel_email'] = "Required field"
            valid = false;
        } else {
            let emailValidate = ValidateUtility.validate_email(tempFormData.hotel_email.trim());
            if (!emailValidate) {
                tempErrorFormData['hotel_email'] = props.t('validEmail')
                valid = false;
            } else {
                tempErrorFormData['hotel_email'] = ""
            }
        }

        if (tempFormData.hotel_contact_number == "" || tempFormData.hotel_contact_number == null) {
            tempErrorFormData['hotel_contact_number'] = "Required field"
            valid = false
        } else {
            let modifiedString = ValidateUtility.deleteAndBefore(tempFormData.hotel_contact_number, phoneNumberDialCode);
            let countryCodeValue = phoneNumberCountryCode.toUpperCase();
            const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
            if (phoneNumber && phoneNumber.isValid()) {
                tempErrorFormData['hotel_contact_number'] = ""
            } else {
                tempErrorFormData['hotel_contact_number'] = "Enter valid phone number"
                valid = false
            }
        }

        if (tempFormData.hotel_address1.trim() == "" || tempFormData.hotel_address1 == null) {
            tempErrorFormData['hotel_address1'] = "Required field"
            valid = false
        }

        if (tempFormData.hotel_city.trim() == "" || tempFormData.hotel_city == null) {
            tempErrorFormData['hotel_city'] = "Required field"
            valid = false
        }

        if (tempFormData.hotel_state.trim() == "" || tempFormData.hotel_state == null) {
            tempErrorFormData['hotel_state'] = "Required field"
            valid = false
        }

        if (tempFormData.hotel_zip_code.trim() == "" || tempFormData.hotel_zip_code == null) {
            tempErrorFormData['hotel_zip_code'] = "Required field"
            valid = false
        }

        if (tempFormData.hotel_country.trim() == "" || tempFormData.hotel_country == null) {
            tempErrorFormData['hotel_country'] = "Required field"
            valid = false
        }

        if (tempFormData.hotel_gstin_number.trim() !== "") {
            let gstnValidate = ValidateUtility.validate_gstn_Number(tempFormData.hotel_gstin_number.trim());
            if (gstnValidate) {

            } else {
                valid = false;
                tempErrorFormData['hotel_gstin_number'] = "Enter correct gstin number"
            }
        }

        if (tempFormData.hotel_pan_number.trim() !== "") {
            let panValidate = ValidateUtility.validate_pan_Number(tempFormData.hotel_pan_number.trim());
            if (panValidate) {
            } else {
                valid = false;
                tempErrorFormData['hotel_pan_number'] = "Enter correct pan number"
            }
        }

        // let tempHotelFirstName = tempFormData.first_name;
        // let trimmedTempHotelFirstName = tempHotelFirstName.trim();
        // if (trimmedTempHotelFirstName == "") {
        //     tempErrorFormData['first_name'] = "Required field"
        //     valid = false
        // }

        // let tempHotelLastName = tempFormData.last_name;
        // let trimmedTempHotelLastName = tempHotelLastName.trim();
        // if (trimmedTempHotelLastName == "") {
        //     tempErrorFormData['last_name'] = "Required field"
        //     valid = false
        // }

        // if (tempFormData.contact_number == "" || tempFormData.contact_number == null) {
        //     tempErrorFormData['contact_number'] = "Required field"
        //     valid = false
        // } else {
        //     let modifiedString = ValidateUtility.deleteAndBefore(tempFormData.contact_number, phoneNumberDialCodeAdmin);
        //     let countryCodeValue = phoneNumberCountryCodeAdmin.toUpperCase();
        //     const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
        //     if (phoneNumber && phoneNumber.isValid()) {
        //         tempErrorFormData['contact_number'] = ""
        //     } else {
        //         tempErrorFormData['contact_number'] = "Enter valid phone number"
        //         valid = false
        //     }
        // }

        // if (tempFormData.email.trim() == "") {
        //     tempErrorFormData['email'] = "Required field"
        //     valid = false;
        // } else {
        //     let emailValidate = ValidateUtility.validate_email(tempFormData.email.trim());
        //     if (!emailValidate) {
        //         tempErrorFormData['email'] = props.t('validEmail')
        //         valid = false;
        //     } else {
        //         tempErrorFormData['email'] = ""
        //     }
        // }

        if (tempFormData.selectedTimezone == "") {
            tempErrorFormData['selectedTimezone'] = "Required field"
            valid = false;
        }

        if (tempFormData.max_branch == "" || tempFormData.max_branch == null) {
            tempErrorFormData['max_branch'] = "Required field"
            valid = false;
        } else if (parseInt(tempFormData.max_branch) < 1) {
            tempErrorFormData['max_branch'] = "Store limit must be at least 1"
            valid = false;
        } else {
            tempErrorFormData['max_branch'] = ""
        }

        if (Object.keys(selectedVersion).length == 0) {
            tempErrorFormData['version'] = "Required field"
            valid = false;
        }

        // if (tempFormData.domain.trim() == "") {
        //     tempErrorFormData['domain'] = "Required field"
        //     valid = false;
        // }
        //For agency only in v4=================
        // if (selectedVersion?.value == "v4" && isCheckedAgent) {
        //     if (tempFormData.agency_name == "" || tempFormData.agency_name == undefined) {
        //         tempErrorFormData['agency_name'] = "Required field"
        //         valid = false
        //     }
        //     if (tempFormData.agency_image == "" || tempFormData.agency_image == null) {
        //         valid = false;
        //         tempErrorFormData['agency_image'] = "Required field"
        //     }

        //     if (tempFormData.agency_email.trim() == "" || tempFormData.agency_email == null) {
        //         tempErrorFormData['agency_email'] = "Required field"
        //         valid = false;
        //     } else {
        //         let emailValidate = ValidateUtility.validate_email(tempFormData.agency_email.trim());
        //         if (!emailValidate) {
        //             tempErrorFormData['agency_email'] = props.t('validEmail')
        //             valid = false;
        //         } else {
        //             tempErrorFormData['agency_email'] = ""
        //         }
        //     }
        //     if (tempFormData.agency_contact_number == "" || tempFormData.agency_contact_number == null) {
        //         tempErrorFormData['agency_contact_number'] = "Required field"
        //         valid = false
        //     } else {
        //         let modifiedString = ValidateUtility.deleteAndBefore(tempFormData.agency_contact_number, phoneNumberDialCodeForAgency);
        //         let countryCodeValue = phoneNumberCountryCodeForAgency.toUpperCase();
        //         const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
        //         if (phoneNumber && phoneNumber.isValid()) {
        //             tempErrorFormData['agency_contact_number'] = ""
        //         } else {
        //             tempErrorFormData['agency_contact_number'] = "Enter valid phone number"
        //             valid = false
        //         }
        //     }

        //     if (tempFormData.agency_address1.trim() == "" || tempFormData.agency_address1 == null) {
        //         tempErrorFormData['agency_address1'] = "Required field"
        //         valid = false
        //     }

        //     if (tempFormData.agency_city.trim() == "" || tempFormData.agency_city == null) {
        //         tempErrorFormData['agency_city'] = "Required field"
        //         valid = false
        //     }

        //     if (tempFormData.agency_state.trim() == "" || tempFormData.agency_state == null) {
        //         tempErrorFormData['agency_state'] = "Required field"
        //         valid = false
        //     }

        //     if (tempFormData.agency_zipcode.trim() == "" || tempFormData.agency_zipcode == null) {
        //         tempErrorFormData['agency_zipcode'] = "Required field"
        //         valid = false
        //     }

        //     if (tempFormData.agency_gstin_number.trim() !== "" && tempFormData.agency_gstin_number != "undefined" && tempFormData.agency_gstin_number != null) {
        //         let gstnValidate = ValidateUtility.validate_gstn_Number(tempFormData.agency_gstin_number);
        //         if (gstnValidate) {

        //         } else {
        //             valid = false;
        //             tempErrorFormData['agency_gstin_number'] = "Enter correct gstin number"
        //         }
        //     }
        //     if (tempFormData.agency_pan_number.trim() !== "" && tempFormData.agency_pan_number != "undefined" && tempFormData.agency_pan_number != null) {
        //         let panValidate = ValidateUtility.validate_pan_Number(tempFormData.agency_pan_number);
        //         if (panValidate) {
        //         } else {
        //             valid = false;
        //             tempErrorFormData['agency_pan_number'] = "Enter correct pan number"
        //         }
        //     }

        // }
        setErrorFormData(tempErrorFormData)
        return valid
    }

    //hote create and update save function
    const hotelDataSave = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let vaildData = validationFromData();
        if (vaildData) {
            loaderStateTrue();
            let data = formatingHotelDataset();
            let type = 'post';
            let id = ""

            if (editedHotelFlag) {
                id = editedHotelId
                type = "patch";
                data = data[0];
            }
            //hotel creae and update api
            hotelCreate(data, id, type).then((response) => {
                if (type == "post") {
                    // console.log('response----->', response)
                    if (response.length > 0) {
                        response.forEach((item) => {
                            if (item.success) {
                                resetDataGrid();
                                closeHotelModal();
                                Utility.toastNotifications(item.message, "Success", "success");
                            } else {
                                Utility.toastNotifications(item.message, "Error", "error");
                            }
                        });
                        loaderStateFalse();
                        // if (org_response) {
                        //     // adminDataSave(response);
                        // }
                    }
                } else {
                    if (response.success) {
                        resetDataGrid();
                        closeHotelModal();
                        loaderStateFalse();
                        Utility.toastNotifications(item.message, "Success", "success");
                        // adminDataSave(editedHotelId, response.message);
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error")
                        loaderStateFalse();
                    }
                }
            }).catch((error) => {
                loaderStateFalse();
            });
        }
    }

    //admin create and update fn
    const adminDataSave = (res) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let vaildData = validationFromData();
        if (vaildData) {
            let data = formatingAdminDataset(res);
            let type = 'post';
            let id = ""
            if (editedHotelFlag) {
                id = editedAdminId
                type = "patch";
                data = data[0];
            }
            loaderStateTrue();
            adminCreate(data, id, type).then((response) => {
                if (type == "post") {
                    if (response.length > 0) {
                        response.map((data) => {
                            if (data.success) {
                                resetDataGrid();
                                closeHotelModal();
                                let hotelAddEditSuccessMessage = ''
                                if (res.length > 0) {
                                    res.forEach((item) => {
                                        if (item.success) {
                                            hotelAddEditSuccessMessage = item.message;
                                        }
                                    });
                                }
                                Utility.toastNotifications(hotelAddEditSuccessMessage, "Success", "success")
                                loaderStateFalse();
                            } else {
                                Utility.toastNotifications(data.message, "Error", "error")
                                loaderStateFalse();
                            }
                        })
                    }
                } else {
                    if (response.success) {
                        resetDataGrid();
                        closeHotelModal();
                        // Utility.toastNotifications(hotelAddEditSuccessMessage, "Success", "success");
                        loaderStateFalse();
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error")
                        loaderStateFalse();
                    }
                }
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();
            });
        }
    }

    //modal zoom-in fn
    const zoominFunction = () => {
        let zoominzoomoutflag = "zoominzoomoutclassDialog"
        setZoominzoomoutflag(zoominzoomoutflag)
    }

    //modal zoom-out fn
    const zoomoutFunction = () => {
        let zoominzoomoutflag = ""
        setZoominzoomoutflag(zoominzoomoutflag)
    }

    //delete option click fn from hotel grid 
    const deleteHotel = (params) => {
        setDeleteConfirmationAlertModal(true)
        setDeleteBodySecondContent(params.data.name)
        setHotelDeleteObj(params.data)
    }

    //delete hotel confirmation modal close fn
    const deleteConfirmationModalHide = () => {
        setDeleteConfirmationAlertModal(false)
        setDeleteBodySecondContent("")
        setHotelDeleteObj({})
    }

    //delete hotel confirmattion modal confirm buton click
    const deleteConfirmButton = () => {
        hotelDeleteFn()
    }

    //delete hotel confirmattion modal cancel buton click
    const deleteCancleButton = () => {
        deleteConfirmationModalHide();
    }

    //hotel delete api fn
    const hotelDeleteFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        let data = {}
        data['id'] = [hotelDeleteObj.id]
        hotelDelete(data).then((response) => {
            if (response.success) {
                resetDataGrid()
                deleteConfirmationModalHide()
                resetFromData()
                Utility.toastNotifications(response.data[0].message, "Success", "success")
            } else {
                Utility.toastNotifications(response.data[0].message, "Error", "error")
            }
            loaderStateFalse();
        }).catch((error) => {
            if (error) {
            }
            loaderStateFalse();
            if (error.message == "Network Error") {

            }
        });
    }

    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);

    //subscription list api get fn
    const subscriptionList = (data) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue()
        let filters = {}
        subscriptionListApi(filters).then((response) => {
            if (response) {
                if (response.success) {
                    let newKeyAdd = response.data.map(obj => ({ ...obj, label: obj.subscription_name, value: obj.id }));
                    setSubscriptionList(newKeyAdd)
                    setReserveSubscriptionList(newKeyAdd)
                }
                loaderStateFalse()
            }
        }).catch((error) => {
            if (error) {
            }
            loaderStateFalse();
            if (error.message == "Network Error") {
            }
        });

    }

    //cancellation option click fn from organization grid 
    const cancellationSubscription = (params) => {
        //console.log("params.data======", params.data)
        setCancellationSubscriptionPopupFlag(true)
        setDeleteBodySecondContent(params.data?.OrganisationSubscriptions[0]?.SubscriptionTypeDetails?.subscription_name || "")
        setSelectedRowSubscriptionData(params.data?.OrganisationSubscriptions[0]?.id || "")
        setHotelDeleteObj(params.data)
    }

    //cancellation organization Subscription confirmation modal close fn
    const cancellationConfirmationModalHide = () => {
        setCancellationSubscriptionPopupFlag(false)
        setDeleteBodySecondContent("")
        setSelectedRowSubscriptionData("")
        setHotelDeleteObj({})
        setSelectedCancellationPolicy("withoutRefund")
    }

    //cancellation organization Subscription confirmattion modal confirm buton click
    const cancellationConfirmButton = () => {
        organizationcancellationSubscriptionFn()
    }

    //cancellation organization Subscription confirmattion modal cancel buton click
    const cancellationCancleButton = () => {
        cancellationConfirmationModalHide();
    }

    const refundAmountValidationFn = () => {
        let valid = true;

        if (selectedCancellationPolicy === 'withRefund') {
            if (cancellationSubscriptionRefundAmount === "") {
                setCancellationSubscriptionRefundError("Please enter refunded amount");
                valid = false;
            } else if (Number(cancellationSubscriptionRefundAmount) <= 0) {
                setCancellationSubscriptionRefundError("Refund amount must be greater than 0");
                valid = false;
            } else {
                setCancellationSubscriptionRefundError("");
            }
        }

        return valid;
    };

    //organization Subscription cancellation api fn
    const organizationcancellationSubscriptionFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let vaildData = refundAmountValidationFn();
        //console.log("vaildData=====", vaildData)
        if (vaildData) {
            let data = {}
            data['sub_det_id'] = selectedRowSubscriptionData
            data['is_refund_intiate'] = selectedCancellationPolicy === 'withRefund' ? true : false
            data['refunded_amt'] = selectedCancellationPolicy === 'withRefund' ? cancellationSubscriptionRefundAmount : 0
            //console.log("data=======",data)
            // return false;
            loaderStateTrue();
            hotelSubscriptionCancelApi(data).then((response) => {
                if (response.success) {
                    resetDataGrid()
                    cancellationConfirmationModalHide()
                    resetFromData()
                    Utility.toastNotifications(response.data[0].message, "Success", "success")
                } else {
                    Utility.toastNotifications(response.data[0].message, "Error", "error")
                }
                loaderStateFalse();
            }).catch((error) => {
                if (error) {
                }
                loaderStateFalse();
                if (error.message == "Network Error") {

                }
            });
        }
    }

    //refund amount api get fn
    const refundAmountDetailsFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let filters = {};
        let globalQueryParamshash = {};
        globalQueryParamshash["sub_det_id"] = selectedRowSubscriptionData;
        filters['filters'] = JSON.stringify(globalQueryParamshash)
        loaderStateTrue();
        refundAmountDetailsApi(filters).then((response) => {
            if (response) {
                if (response.success) {
                    // setRefundAmountData(response.data[0])
                    const refundAmount = parseFloat(response?.refund_amount);
                    setCancellationSubscriptionRefundAmount(
                        isNaN(refundAmount) ? 0 : refundAmount.toFixed(2)
                    );
                } else{
                    setCancellationSubscriptionRefundAmount("")
                }
                loaderStateFalse()
            }
        }).catch((error) => {
            if (error) {
                setCancellationSubscriptionRefundAmount("")
            }
            loaderStateFalse();
            if (error.message == "Network Error") {
            }
        });
    }

    //refund amount handle change fn
    const handelChangeRefundSwitchFn = (e, type) => {
        if (e.target.checked) {
            setSelectedCancellationPolicy(type)
            if (type === 'withRefund') {
                refundAmountDetailsFn();
            }
        }
    }

    //refund amount input change fn
    const handelChangeRefundAmount = (e, type) => {
        let tempValue = e.target.value;
        if (type === 'refund_amount') {
            if (tempValue === "") {
                setCancellationSubscriptionRefundAmount("")
                setCancellationSubscriptionRefundError("")
            } else {
                // Allow only decimal numbers with up to 2 decimal places
                const regex = /^\d*\.?\d{0,2}$/;
                if (regex.test(tempValue)) {
                    setCancellationSubscriptionRefundAmount(tempValue)
                    setCancellationSubscriptionRefundError("")
                }
            }
        }
    }

    //Initially call fetch subscription list get api
    useEffect(() => {
        subscriptionList();
    }, [])
    useEffect(() => {
    }, [subscriptionListData, selectedSubscription, reservesubscriptionListData])

    //subscription change onchange fn
    const handleChangesubscriptionList = (e) => {
        if (e) {
            setSelectedSubscription(e)
        } else {
            setSelectedSubscription("")
        }
    }

    //subscription pay click fn
    const addNewSubscription = () => {
        setPaymentModeModalFlag(true);
    }

    //close payment modal fn
    const closePaymentModeModalFn = () => {
        setPaymentModeModalFlag(false);
    }

    //after successfull pay , close payment modal and subscription modal both 
    const closeallModal = () => {
        setsubscribeModalFlag(false)
        setPaymentModeModalFlag(false);
        setSelectedSubscription("")
        resetDataGrid();
        setextendDays(7)
    }

    //extend subscription button click fn
    const addExtendSubscription = () => {
        let dataSet;
        dataSet = [{
            hotel_id: Object.keys(gridObjData).length > 0 ? gridObjData.data.id : "",
            subscription_type_id: selectedSubscription.value,
            extend_days: extendDays,
            subscription_type: 'extend_date',
        }]
        loaderStateTrue();
        subscribApiCall(dataSet).then((response) => {
            if (response.length > 0) {
                if (response[0].success) {
                    closeallModal();
                    Utility.toastNotifications(response[0].message, "Success", "success");
                } else {
                    Utility.toastNotifications(response[0].message, "Error", "error");
                }
            }
            loaderStateFalse();
        }).catch((error) => {
            console.error("************error*************", error)
            if (error) {
            }
            loaderStateFalse();
            if (error.message == "Network Error") {

            }
        });
    }

    //subscription extend days choose handlechange function
    const handleExtendSubscrib = (e, type) => {
        if (e.target.checked) {
            setextendDays(type)
        }
    }

    //also an agent checkbox check fn
    const handleCheckboxChange = (e) => {
        if (e.target.checked) {
            setIsCheckedAgent(e.target.checked);
        } else {
            setIsCheckedAgent(false);
            let tempformData = { ...formData };
            let tempErrorFormData = { ...errorFormData }
            let agentObj = {};
            let agentErrorObj = {};
            setSelectedStateForAgency("")
            setSelectedCityForAgency("")
            setAddHotelImagePreviewShow(false)
            setAddHotelImageSelected(require('../Utility/Public/images/hotel.png'))
            agentObj = {
                "agency_name": "",
                "agency_email": "",
                "agency_address1": "",
                "agency_address2": "",
                "agency_zipcode": "",
                "agency_country": "india",
                "agency_contact_number": "",
                "agency_state": "",
                "agency_city": "",
                "agency_gstin_number": "",
                "agency_pan_number": "",
                "agency_image": "",
            }
            agentErrorObj = {
                "agency_name": "",
                "agency_email": "",
                "agency_address1": "",
                "agency_address2": "",
                "agency_zipcode": "",
                "agency_country": "",
                "agency_contact_number": "",
                "agency_state": "",
                "agency_city": "",
                "agency_gstin_number": "",
                "agency_pan_number": "",
                "agency_image": ""
            }
            tempformData = { ...tempformData, ...agentObj };
            tempErrorFormData = { ...tempErrorFormData, ...agentErrorObj };
            setFormData(tempformData)
            setErrorFormData(tempErrorFormData)
        }
    };

    //hotel grid refresh button click fn
    const loadGrid = () => {
        resetDataGrid();
    }

    //For Agency country option list create============
    const getCountryOptionForAgency = () => {
        if (CountryListForAgency.length == 0) {
            setCountryListForAgency([]);
            Country.getAllCountries().map((countryObj) => {
                setCountryListForAgency(prevArray => [...prevArray, { label: countryObj.name, value: countryObj.isoCode, country_code: countryObj.phonecode, iso_code: countryObj.isoCode }]);
            })
        }
    }

    //For Agency state option list create============
    const getStateOptionForAgency = (countryId = "") => {
        setStateListForAgency([]);
        if (countryId != "") {
            State.getStatesOfCountry(countryId).map((stateObj) => {
                setStateListForAgency(prevArray => [...prevArray, { label: stateObj.name, value: stateObj.isoCode, country_id: stateObj.countryCode }]);
            })
        } else {
            setStateListForAgency([]);
        }
    }

    //For Agency city option list create============
    const getCityOptionForAgency = (state_code = "", country_code = "", sameCity = "") => {
        let tempformData = { ...formData }
        setCityListForAgency([]);
        if (state_code != "") {
            City.getCitiesOfState(country_code.toUpperCase().toString(), state_code.toUpperCase().toString()).map((cityObj) => {
                setCityListForAgency(prevArray => [...prevArray, { label: cityObj.name, value: cityObj.name, country_id: cityObj.countryCode }]);
            })


        }
    }

    //same as admin checkbox click fn
    const agentAdminSameAddress = (e) => {
        let tempformData = { ...formData };
        let tempErrorFormData = { ...errorFormData }
        let agentObj = {};
        let agentErrorObj = {};
        if (e.target.checked) {
            let agencyCountry = CountryListForAgency.find((val) => val.label.toLowerCase() == tempformData.hotel_country.toLowerCase());
            setSelectedCountryForAgency(agencyCountry)
            let agencyCountryArr = []
            Country.getAllCountries().map((countryObj) => {
                agencyCountryArr.push({ label: countryObj.name, value: countryObj.isoCode, country_code: countryObj.phonecode, iso_code: countryObj.isoCode })
            })

            let agencyStateArr = []
            State.getStatesOfCountry(agencyCountry.value).map((stateObj) => {
                agencyStateArr.push({ label: stateObj.name, value: stateObj.isoCode, country_id: stateObj.countryCode })
            })
            let agencyState = agencyStateArr.find((val) => val.label.toLowerCase() == tempformData.hotel_state.toLowerCase());
            setSelectedStateForAgency(agencyState)
            if (tempformData.hotel_state != "") {
                let agencyCity = []
                City.getCitiesOfState(agencyState.country_id.toUpperCase().toString(), agencyState.value.toUpperCase().toString()).map((cityObj) => {
                    agencyCity.push({ label: cityObj.name, value: cityObj.name, country_id: cityObj.countryCode });
                })
                setCityListForAgency(agencyCity);
                let agentCity = agencyCity.find((val) => val.label.toLowerCase() == tempformData.hotel_city.toLowerCase());
                setSelectedCityForAgency(agentCity)
            }

            agentObj = {
                "agency_email": tempformData.hotel_email,
                "agency_address1": tempformData.hotel_address1,
                "agency_address2": tempformData.hotel_address2,
                "agency_zipcode": tempformData.hotel_zip_code,
                "agency_country": tempformData.hotel_country,
                "agency_contact_number": tempformData.hotel_contact_number,
                "agency_state": tempformData.hotel_state,
                "agency_city": tempformData.hotel_city,
                "agency_gstin_number": tempformData.hotel_gstin_number,
                "agency_pan_number": tempformData.hotel_pan_number,
                'agency_mfa_required': tempformData.is_mfa_required
            }

        } else {
            setSelectedStateForAgency("")
            setSelectedCityForAgency("")
            agentObj = {
                "agency_email": "",
                "agency_address1": "",
                "agency_address2": "",
                "agency_zipcode": "",
                "agency_country": "india",
                "agency_contact_number": "+91",
                "agency_state": "",
                "agency_city": "",
                "agency_gstin_number": "",
                "agency_pan_number": "",
                'agency_mfa_required': false
            }
        }
        agentErrorObj = {
            "agency_email": "",
            "agency_address1": "",
            "agency_address2": "",
            "agency_zipcode": "",
            "agency_country": "",
            "agency_contact_number": "",
            "agency_state": "",
            "agency_city": "",
            "agency_gstin_number": "",
            "agency_pan_number": ""
        }

        tempformData = { ...tempformData, ...agentObj };
        tempErrorFormData = { ...tempErrorFormData, ...agentErrorObj };
        setFormData(tempformData)
        setErrorFormData(tempErrorFormData)
    }

    const showPopup = (relations) => {
        // Use a modal component to display the data
        setAdminDetailsData(relations);
        setAdminDetailsPopUpShowFlag(true);
    };

    const closeadminDetailsPopUpFn = () => {
        setAdminDetailsPopUpShowFlag(false);
        setAdminDetailsData([]);
        setZoominzoomoutflag("")
    }

    //subscription price calculate
    let subscriptionPrice = gridObjData.data && gridObjData.data.hasOwnProperty('OrganisationSubscriptions') && gridObjData.data.OrganisationSubscriptions[0] && gridObjData.data.OrganisationSubscriptions[0].hasOwnProperty('SubscriptionTypeDetails') && gridObjData.data.OrganisationSubscriptions[0].SubscriptionTypeDetails.hasOwnProperty('subscription_price') && gridObjData.data.OrganisationSubscriptions[0].SubscriptionTypeDetails.subscription_price

    useEffect(() => {
    }, [phoneNumberDialCode, phoneNumberCountryCode, phoneNumberCountryCodeAdmin, phoneNumberDialCodeAdmin])

    return (
        <div className="gridcontainer hotelGridContainer orgContainer">
            <div className="totalworkercontentBox">
                {props.hotelFilterShow &&
                    <>
                        <div className="gridtopviews gridtopviewsHistory gridtopviewsAllSectionBox">
                            <div className="rightboxesSec">
                                <CustomButton
                                    onClick={createHotelModalFn}
                                    className="customButtonClassBox"
                                    children="Add"
                                />
                            </div>
                        </div>
                        <div className='filterSectionBox'>
                            <div className="gridtopviews gridtopviewsHistory">
                                <div className="dropdownBoxContainer statusdropcontainerBox">
                                    <AutosuggestComponent
                                        handleOnChange={(e) => { handleChangeUserFilter('status', e) }}
                                        options={statusList}
                                        selectedValue={selectedStatus}
                                        name=''
                                        isMulti={false}
                                        placeholder="Status"
                                        isDisabled={false}
                                        isClearable={true}
                                        closeButton={false}
                                        menuHeader="Status"
                                        isSearchable={true}
                                        openMenu={true}
                                    />
                                </div>
                                <form id="hotel">
                                    <div className="pageinnersearchBox hotel">
                                        <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                                        <DebounceInput
                                            minLength={2}
                                            debounceTimeout={500}
                                            onChange={(e) => handleSearchValue(e)}
                                            placeholder="Search an organization"
                                            value={searchHotelName}
                                            autoComplete="off"
                                        />
                                        {searchHotelName.trim() != "" ?
                                            < button type="button" className="btn btn-link dropclosebtn"
                                                onClick={clearSearchValue}
                                            >
                                                <img src={require('../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                                            </button>
                                            : null}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                }
                <div className='grid_content_inner'>
                    <div className="ag-theme-alpine aggridviewSection" style={{ position: 'relative' }}>
                        <div className="leadButtonInnerBox"><button className="buttonload" onClick={() => { loadGrid() }} data-tip="Refresh"><RefreshButton
                            isAnimating={isAnimating}
                        />
                        </button>
                            <ReactTooltip place="bottom" />
                        </div>
                        <AgGridReact
                            modules={modules}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            components={components}
                            rowSelection="single"
                            rowModelType="infinite"
                            onGridReady={onGridReady}
                            rowHeight={43.9}
                            headerHeight={40.8}
                            cacheBlockSize={process.env.PAGE_DATA_LIMIT}
                            gridOptions={gridOptions}
                            noRowsOverlayComponent={noRowsOverlayComponent}
                            ref={gridRef}
                        />
                    </div>
                </div>
            </div>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={hotelCreateModalFlag}
                    onHide={closeHotelModal}
                    title={hotelModalTitle}
                    className={` ${zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension organizationModalDialog"}`}
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    zoominButton={zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={zoominzoomoutflag != "" ? true : false}
                    zoomin={zoominFunction}
                    zoomout={zoomoutFunction}

                    body={
                        <>
                            <ErrorBoundary title="OrganizationAddEditModalContent Error">
                                <OrganizationAddEditModalContent
                                    closeHotelModal={closeHotelModal}
                                    handelChange={handelChange}
                                    formData={formData}
                                    errorFormData={errorFormData}
                                    hotelDataSave={hotelDataSave}
                                    //Image crop for hotel start
                                    hotelCrop={hotelCrop}
                                    hotelCroppedImageUrl={hotelCroppedImageUrl}
                                    hotelSrc={hotelSrc}
                                    onHotelImageLoaded={onHotelImageLoaded}
                                    onHotelCropComplete={onHotelCropComplete}
                                    onCropChangeHotel={onCropChangeHotel}
                                    hotelImageCropModalShow={hotelImageCropModalShow}
                                    hotelImageCropModalHide={hotelImageCropModalHide}
                                    hotelImageCropModalFlag={hotelImageCropModalFlag}
                                    hotelImageCropDataSave={hotelImageCropDataSave}
                                    addHotelImageSelected={addHotelImageSelected}
                                    addInputHotelImageChanged={addInputHotelImageChanged}
                                    addHotelImagePreviewShow={addHotelImagePreviewShow}
                                    circularCrop={false}
                                    //Image crop for admin start
                                    crop={crop}
                                    croppedImageUrl={croppedImageUrl}
                                    src={src}
                                    onImageLoaded={onImageLoaded}
                                    onCropComplete={onCropComplete}
                                    onCropChange={onCropChange}
                                    imageCropModalShow={imageCropModalShow}
                                    imageCropModalHide={imageCropModalHide}
                                    imageCropModalFlag={imageCropModalFlag}
                                    imageCropDataSave={imageCropDataSave}
                                    addprofileImageSelected={addprofileImageSelected}
                                    addInputProfileImageChanged={addInputProfileImageChanged}
                                    addProfileImagePreviewShow={addProfileImagePreviewShow}
                                    //Image crop for admin end
                                    editedHotelFlag={editedHotelFlag}
                                    CountryList={CountryList}
                                    selectedCountry={selectedCountry}
                                    selectedCountryCode={selectedCountryCode}
                                    StateList={StateList}
                                    selectedState={selectedState}
                                    CityList={CityList}
                                    selectedCity={selectedCity}
                                    versionList={versionList}
                                    selectedVersion={selectedVersion}
                                    handleCheckboxChange={handleCheckboxChange}
                                    isCheckedAgent={isCheckedAgent}
                                    //Agent
                                    CountryListForAgency={CountryListForAgency}
                                    selectedCountryForAgency={selectedCountryForAgency}
                                    selectedCountryCodeForAgency={selectedCountryCodeForAgency}
                                    StateListForAgency={StateListForAgency}
                                    selectedStateForAgency={selectedStateForAgency}
                                    CityListForAgency={CityListForAgency}
                                    selectedCityForAgency={selectedCityForAgency}
                                    agentAdminSameAddress={agentAdminSameAddress}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
            {actionModalflag ?
                <>
                    <ErrorBoundary title="GridActionContent Error">
                        <GridActionContent
                            styleWidth={overlayWidth}
                            styleHight={overlayHight}
                            codeOutsideClickRef={actionOutsideClickRef}
                            gridObjData={gridObjData}
                            modefier={editHotel}
                            delete={deleteHotel}
                            archivedButtonShow={false}
                            editButtonShow={true}
                            deleteButtonShow={false}
                            subscribeNow={gridObjData.data.subscption_status == 3 && gridObjData.data.hasOwnProperty('OrgUserRelation') && gridObjData.data.OrgUserRelation.length > 0 || parseFloat(subscriptionPrice) == 0 && gridObjData.data.hasOwnProperty('OrgUserRelation') && gridObjData.data.OrgUserRelation.length > 0 ? true : false}
                            // subscribeNow={true}
                            renewsubscribe={(gridObjData.data.subscption_status == 0 || gridObjData.data.subscption_status == 1 || gridObjData.data.subscption_status == 4) && parseFloat(subscriptionPrice) > 0 ? true : false}
                            subscribeExtendNow={gridObjData.data.subscption_status == 1 && !gridObjData.data.is_date_extended && parseFloat(subscriptionPrice) > 0 ? true : false}
                            opensubscribeModal={opensubscribeModal}
                            cancelSubscription={gridObjData.data.subscption_status == 1 || gridObjData.data.subscption_status == 2 || (gridObjData.data.subscption_status == 3 && gridObjData.data.hasOwnProperty('OrganisationSubscriptions') && gridObjData.data.OrganisationSubscriptions.length > 0 && gridObjData.data.OrganisationSubscriptions[0].hasOwnProperty('SubscriptionTypeDetails') && parseInt(gridObjData.data.OrganisationSubscriptions[0].SubscriptionTypeDetails.subscription_price) == 0) ? true : false}
                            cancelSubscriptionModal={cancellationSubscription}
                            // walinerConfig={true}
                            walinerConfig={gridObjData?.data?.OrgMetaRelation?.is_waliner_enabled ? true : false}
                            walinerConfigFn={walinerConfigFn}
                            // walinerTemplate={true}
                            walinerTemplate={gridObjData?.data?.OrgMetaRelation?.is_waliner_enabled ? true : false}
                            walinerTemplateFn={walinerTemplateFn}

                        />
                    </ErrorBoundary>
                </>
                : null}

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={deleteConfirmationAlertModal}
                    onHide={deleteConfirmationModalHide}
                    className="modalcustomizeDialog confirmationalertmodalDialog"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Delete This Hotel?"
                    footer={false}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Do you confirm the deletion of the"
                                    BodySecondContent={deleteBodySecondContent}
                                    BodyThirdContent="hotel definitely? You won't be able to go back."
                                    confirmationButtonContent="confirm"
                                    cancelButtonContent="cancel"
                                    deleteConfirmButton={deleteConfirmButton}
                                    deleteCancleButton={deleteCancleButton}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            {/* subscription modal open */}
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={subscribeModalFlag}
                    onHide={closesubscribeModalFn}
                    title={subscriptionModalTitle}
                    className="modalcustomizeDialog subscribeModalDialog paymentModalContent"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Payment"
                    saveButtonClassName="btn btn-primary savebtn modbtn"
                    cancelShow={true}
                    cancelButtonLabel={"Cancel"}
                    cancelButtonClassName="modbtn cancelbtn"
                    footerClassName="text-center topspace"
                    body={
                        <>
                            <ErrorBoundary title="BranchAddEditModalContent Error">
                                <SubscribeModal
                                    subscriptionListData={subscriptionListData}
                                    handleChangesubscriptionList={handleChangesubscriptionList}
                                    selectedSubscription={selectedSubscription}
                                    closeSubscriptionModal={closesubscribeModalFn}
                                    addNewSubscription={addNewSubscription}
                                    gridObjData={gridObjData}
                                    subscriptionModalTitle={subscriptionModalTitle}
                                    addExtendSubscription={addExtendSubscription}
                                    handleExtendSubscrib={handleExtendSubscrib}
                                    extendDays={extendDays}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            {/* payment modal open */}
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={paymentModeModalFlag}
                    onHide={closePaymentModeModalFn}
                    title={paymentModeModalHeaderTitle}
                    className={` ${zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension paymentModalContent paymentModeModalContent paymentModeModalSection"}`}
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn modbtn"
                    cancelShow={true}
                    zoominButton={zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={zoominzoomoutflag != "" ? true : false}
                    zoomin={zoominFunction}
                    zoomout={zoomoutFunction}
                    cancelButtonLabel={"Cancel"}
                    cancelButtonClassName="modbtn cancelbtn"
                    footerClassName="text-center topspace"
                    body={
                        <>
                            <ErrorBoundary title="BranchAddEditModalContent Error">
                                <PaymentModeModalContent
                                    isFirstPayment={true}
                                    currency=""
                                    callFrom='subscription'
                                    subscribeHotelId={Object.keys(gridObjData).length > 0 ? gridObjData.data.id : ""}
                                    subscribeAmount={parseFloat(selectedSubscription.subscription_price) + parseFloat(selectedSubscription.cgst_amt) + parseFloat(selectedSubscription.sgst_amt)}
                                    subscription_type_id={selectedSubscription.value}
                                    closeallModal={closeallModal}
                                    closePaymentModeModalFnChild={closePaymentModeModalFn}
                                    subscriptionFor={'admin'}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={cancellationSubscriptionPopupFlag}
                    onHide={cancellationConfirmationModalHide}
                    className="modalcustomize confirmationalertmodalDialog refundConfirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Cancel This Subscription?"
                    footer={false}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Do you confirm the cancel of the"
                                    BodySecondContent={`${deleteBodySecondContent} subscription definitely? You won't be able to go back.`}
                                    BodyThirdContent={
                                        (() => {
                                            const hasSubscriptionPrice =
                                                hotelDeleteObj.OrganisationSubscriptions?.length > 0 &&
                                                parseInt(hotelDeleteObj.OrganisationSubscriptions[0].SubscriptionTypeDetails?.subscription_price || 0) > 0;

                                            if (!hasSubscriptionPrice) return null;

                                            return (
                                                <>
                                                    <div className='refundAmountBox'>
                                                        <div className='chkBoxPanelList'>
                                                            <label className="chkContainer">
                                                                Without Refund
                                                                <input
                                                                    type="radio"
                                                                    checked={selectedCancellationPolicy === 'withoutRefund'}
                                                                    onChange={(e) => handelChangeRefundSwitchFn(e, 'withoutRefund')}
                                                                    name="radio"
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                            <label className="chkContainer">
                                                                With Refund
                                                                <input
                                                                    type="radio"
                                                                    checked={selectedCancellationPolicy === 'withRefund'}
                                                                    onChange={(e) => handelChangeRefundSwitchFn(e, 'withRefund')}
                                                                    name="radio"
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    {selectedCancellationPolicy === 'withRefund' && (
                                                        <div className='refund-amount-container'>
                                                            <CustomInput
                                                                parentClassName="input_field_inner"
                                                                labelName="Refunded Amount"
                                                                errorLabel={cancellationSubscriptionRefundAmountError}
                                                                name="refund_amount"
                                                                type="text"
                                                                value={cancellationSubscriptionRefundAmount}
                                                                onChange={(e) => handelChangeRefundAmount(e, 'refund_amount')}
                                                                labelPresent={true}
                                                                requiredStar={false}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })()
                                    }
                                    confirmationButtonContent="confirm"
                                    cancelButtonContent="cancel"
                                    deleteConfirmButton={cancellationConfirmButton}
                                    deleteCancleButton={cancellationCancleButton}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={adminDetailsPopUpShowFlag}
                    onHide={closeadminDetailsPopUpFn}
                    title={'Admin(s) Details'}
                    className="modalcustomize mondimension multiDetailsDialog"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn modbtn"
                    cancelShow={true}
                    cancelButtonLabel={"Cancel"}
                    cancelButtonClassName="modbtn cancelbtn"
                    footerClassName="text-center topspace"
                    body={
                        <>
                            <ErrorBoundary title="admin details error">
                                <div className='multidetailsContainer'>
                                    {adminDetailsData.length > 0 && adminDetailsData.filter(relation => relation.UserOrgBranchRoleRelation !== null).map((relation, index) => (
                                        <div key={index} className="adminDetail">
                                            <p className='detailsLabel name'>
                                                <strong>Name:</strong>{" "}
                                                {relation.UserOrgBranchRoleRelation?.first_name || "N/A"}{" "}
                                                {relation.UserOrgBranchRoleRelation?.last_name || ""}
                                            </p>
                                            <p className='detailsLabel email'>
                                                <strong>Email:</strong> {relation.UserOrgBranchRoleRelation?.email || "N/A"}
                                            </p>
                                            <p className='detailsLabel contact'>
                                                <strong>Contact:</strong>{" "}
                                                {relation.UserOrgBranchRoleRelation?.contact_number
                                                    ? (relation.UserOrgBranchRoleRelation.contact_number.includes("+")
                                                        ? relation.UserOrgBranchRoleRelation.contact_number
                                                        : "+" + relation.UserOrgBranchRoleRelation.contact_number)
                                                    : "N/A"}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
            {/* Waliner Configuration Modal */}
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={walinerConfigModalFlag}
                    onHide={closeWalinerConfigModalFn}
                    title="Waliner Configuration"
                    className={` ${zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension organizationModalDialog waliner-config-modal-dialog"}`}
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Submit"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    zoominButton={zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={zoominzoomoutflag != "" ? true : false}
                    zoomin={zoominFunction}
                    zoomout={zoomoutFunction}
                    minimizeModal={false}
                    maximizeModal={true}
                    body={
                        <>
                            <ErrorBoundary title="WalinerConfigModalContent Error">
                                <WalinerConfigModalContent
                                    formData={walinerConfigModalData}
                                    orgId={gridObjData?.data?.id}
                                    onClose={closeWalinerConfigModalFn}
                                    loaderStateTrue={props.loaderStateTrue}
                                    loaderStateFalse={props.loaderStateFalse}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
            {/* Waliner Template Mapping Modal  */}
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={walinerTemplateModalFlag}
                    onHide={closeWalinerTemplateModalFn}
                    title="Waliner Template Settings"
                    className={` ${zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension organizationModalDialog waliner-config-modal-dialog"}`}
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Submit"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    zoominButton={zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={zoominzoomoutflag != "" ? true : false}
                    zoomin={zoominFunction}
                    zoomout={zoomoutFunction}
                    minimizeModal={false}
                    maximizeModal={true}
                    body={
                        <>
                            <ErrorBoundary title="WalinerTemplateModalContent Error">
                                <WalinerTemplateModalContent
                                    formData={walinerTemplateModalData}
                                    orgId={gridObjData?.data?.id}
                                    onClose={closeWalinerTemplateModalFn}
                                    loaderStateTrue={props.loaderStateTrue}
                                    loaderStateFalse={props.loaderStateFalse}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
        </div>
    );
};

Organization.defaultProps = {
    hotelFilterShow: true
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(Organization));
